(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-why-choose"] && !Shopify.designMode) return;
  try {
    const gsapScript = document.createElement("script");

gsapScript.src = "https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js";

gsapScript.async = true;

const scrollTriggerScript = document.createElement("script");

scrollTriggerScript.src = "https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js";

scrollTriggerScript.async = true;

gsapScript.onload = () => {
    scrollTriggerScript.onload = () => {
        initWhyChooseCounters();
    };
    document.head.appendChild(scrollTriggerScript);
};

document.head.appendChild(gsapScript);

function initWhyChooseCounters() {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) {
        console.log("Why Choose counter animations disabled: prefers-reduced-motion");
        return;
    }
    gsap.registerPlugin(ScrollTrigger);
    const section = document.querySelector(".about-why-choose");
    if (!section) return;
    const title = section.querySelector(".about-why-choose__title");
    const stats = section.querySelectorAll(".about-why-choose__stat");
    const statNumbers = section.querySelectorAll(".about-why-choose__stat-number");
    const statData = Array.from(statNumbers).map(el => ({
        element: el,
        originalText: el.textContent.trim(),
        targetValue: parseStatValue(el.textContent.trim()),
        type: detectStatType(el.textContent.trim())
    }));
    gsap.set([ title, stats ], {
        opacity: 0,
        y: 20
    });
    statData.forEach(stat => {
        if (stat.type !== "text") {
            stat.element.textContent = formatStatValue(0, stat.type);
            stat.element.style.willChange = "contents";
        }
    });
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: section,
            start: "top 80%",
            once: true,
            toggleActions: "play none none none"
        }
    });
    tl.to(title, {
        opacity: 1,
        y: 0,
        duration: .6,
        ease: "power2.out"
    });
    tl.to(stats, {
        opacity: 1,
        y: 0,
        duration: .5,
        ease: "power2.out"
    }, "-=0.3");
    statData.forEach((stat, index) => {
        if (stat.type === "text") {
            return;
        }
        const counterTween = gsap.to({
            value: 0
        }, {
            value: stat.targetValue,
            duration: 1.5,
            ease: "power2.out",
            onUpdate: function() {
                const currentValue = this.targets()[0].value;
                stat.element.textContent = formatStatValue(currentValue, stat.type);
            },
            onComplete: function() {
                stat.element.textContent = stat.originalText;
                stat.element.style.willChange = "auto";
            }
        });
        tl.add(counterTween, "-=0.5");
    });
    stats.forEach(stat => {
        stat.addEventListener("mouseenter", () => {
            gsap.to(stat, {
                scale: 1.02,
                duration: .3,
                ease: "power2.out"
            });
        });
        stat.addEventListener("mouseleave", () => {
            gsap.to(stat, {
                scale: 1,
                duration: .3,
                ease: "power2.out"
            });
        });
    });
    console.log("Why Choose counter animations initialized:", {
        title: !!title,
        statsCount: stats.length,
        counters: statData.map(s => ({
            type: s.type,
            target: s.targetValue,
            original: s.originalText
        }))
    });
}

function parseStatValue(text) {
    if (text.includes("M+")) {
        return 1e6;
    }
    if (text.includes("%")) {
        return parseInt(text.replace("%", ""), 10);
    }
    const numMatch = text.replace(/,/g, "").match(/\d+/);
    if (numMatch) {
        return parseInt(numMatch[0], 10);
    }
    return null;
}

function detectStatType(text) {
    if (text.includes("M+")) return "millions";
    if (text.includes("%")) return "percentage";
    if (/^\d[\d,]*\+?$/.test(text)) return "number";
    return "text";
}

function formatStatValue(value, type) {
    switch (type) {
      case "millions":
        if (value >= 1e6) {
            return "1M+";
        } else if (value >= 1e5) {
            return Math.floor(value / 1e3) + "K";
        } else {
            return Math.floor(value / 1e3) + "K";
        }

      case "percentage":
        return Math.floor(value) + "%";

      case "number":
        return Math.floor(value).toLocaleString("en-US");

      case "text":
        return value;

      default:
        return Math.floor(value).toString();
    }
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accessories-pdp-main"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const thumbnails = document.querySelectorAll(".accessories-pdp-main__thumbnail");
    const accRoot = document.querySelector(".accessories-pdp-main");
    const L = (k, fallback) => accRoot && accRoot.getAttribute("data-" + k) || fallback;
    const labelAdd = L("add-label", "Add to Cart");
    const labelSoldOut = L("sold-out-label", "Sold Out");
    const labelAdding = L("adding-label", "Adding...");
    const labelInStock = L("in-stock-label", "In Stock");
    const labelOutOfStock = L("out-of-stock-label", "Out of Stock");
    const mainImage = document.getElementById("mainProductImage");
    if (thumbnails.length && mainImage) {
        thumbnails.forEach(thumbnail => {
            thumbnail.addEventListener("click", function() {
                thumbnails.forEach(t => t.classList.remove("active"));
                this.classList.add("active");
                const newImageUrl = this.getAttribute("data-image-url");
                if (newImageUrl && typeof gsap !== "undefined") {
                    gsap.to(mainImage, {
                        opacity: 0,
                        duration: .2,
                        onComplete: () => {
                            mainImage.src = newImageUrl;
                            gsap.to(mainImage, {
                                opacity: 1,
                                duration: .3
                            });
                        }
                    });
                } else if (newImageUrl) {
                    mainImage.src = newImageUrl;
                }
            });
        });
    }
    const quantityInput = document.getElementById("Quantity");
    const decreaseBtn = document.querySelector('[data-action="decrease"]');
    const increaseBtn = document.querySelector('[data-action="increase"]');
    if (quantityInput && decreaseBtn && increaseBtn) {
        decreaseBtn.addEventListener("click", () => {
            const currentValue = parseInt(quantityInput.value) || 1;
            if (currentValue > 1) {
                quantityInput.value = currentValue - 1;
            }
        });
        increaseBtn.addEventListener("click", () => {
            const currentValue = parseInt(quantityInput.value) || 1;
            quantityInput.value = currentValue + 1;
        });
    }
    const variantInputs = document.querySelectorAll(".accessories-pdp-main__option-input");
    const variantDataElement = document.getElementById("productVariantData");
    const variantIdInput = document.getElementById("productVariantId");
    const priceElement = document.getElementById("priceValue");
    const stockStatusElement = document.getElementById("stockStatus");
    const mainImageEl = document.getElementById("mainProductImage");
    const addToCartBtn = document.getElementById("addToCartBtn");
    let variantData = null;
    if (variantDataElement) {
        try {
            variantData = JSON.parse(variantDataElement.textContent);
        } catch (e) {
            console.error("Failed to parse variant data:", e);
        }
    }
    function findVariantByOptions(selectedOptions) {
        if (!variantData || !variantData.variants) return null;
        return variantData.variants.find(variant => selectedOptions.every((option, index) => variant.options[index] === option));
    }
    function getSelectedOptions() {
        const options = [];
        const optionGroups = document.querySelectorAll(".accessories-pdp-main__option");
        optionGroups.forEach(group => {
            const checkedInput = group.querySelector(".accessories-pdp-main__option-input:checked");
            if (checkedInput) {
                options.push(checkedInput.value);
            }
        });
        return options;
    }
    function formatMoney(cents) {
        return "$" + (cents / 100).toFixed(2).replace(/\.00$/, "");
    }
    function updateMainImage(imageUrl) {
        if (!mainImageEl || !imageUrl) return;
        if (mainImageEl.src === imageUrl) return;
        if (typeof gsap !== "undefined") {
            gsap.to(mainImageEl, {
                opacity: 0,
                duration: .2,
                onComplete: () => {
                    mainImageEl.src = imageUrl;
                    mainImageEl.onload = () => {
                        gsap.to(mainImageEl, {
                            opacity: 1,
                            duration: .3
                        });
                    };
                }
            });
        } else {
            mainImageEl.src = imageUrl;
        }
    }
    function updateThumbnailSelection(imageUrl) {
        if (!imageUrl) return;
        const thumbnails = document.querySelectorAll(".accessories-pdp-main__thumbnail");
        if (!thumbnails.length) return;
        let matchFound = false;
        thumbnails.forEach(thumbnail => {
            const thumbUrl = thumbnail.getAttribute("data-image-url");
            if (thumbUrl === imageUrl) {
                thumbnails.forEach(t => t.classList.remove("active"));
                thumbnail.classList.add("active");
                matchFound = true;
            }
        });
        if (!matchFound) {
            const imageFilename = imageUrl.split("/").pop().split("?")[0];
            thumbnails.forEach(thumbnail => {
                const thumbUrl = thumbnail.getAttribute("data-image-url");
                const thumbFilename = thumbUrl ? thumbUrl.split("/").pop().split("?")[0] : "";
                if (thumbFilename && thumbFilename === imageFilename) {
                    thumbnails.forEach(t => t.classList.remove("active"));
                    thumbnail.classList.add("active");
                    matchFound = true;
                }
            });
        }
    }
    function updateVariantUI(variant) {
        if (!variant) return;
        if (variantIdInput) {
            variantIdInput.value = variant.id;
        }
        const installmentsBanner = document.querySelector("shopify-payment-terms");
        if (installmentsBanner && variant.id) {
            installmentsBanner.setAttribute("variant-id", variant.id);
        }
        if (priceElement) {
            priceElement.textContent = formatMoney(variant.price);
            const priceContainer = priceElement.closest(".accessories-pdp-main__price");
            const compareAtElement = priceContainer?.querySelector(".accessories-pdp-main__price-compare");
            const saleBadge = priceContainer?.querySelector(".accessories-pdp-main__price-badge");
            if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
                if (compareAtElement) {
                    compareAtElement.textContent = formatMoney(variant.compareAtPrice);
                    compareAtElement.style.display = "";
                }
                if (saleBadge) saleBadge.style.display = "";
                priceElement.classList.add("accessories-pdp-main__price-sale");
                priceElement.classList.remove("accessories-pdp-main__price-regular");
            } else {
                if (compareAtElement) compareAtElement.style.display = "none";
                if (saleBadge) saleBadge.style.display = "none";
                priceElement.classList.remove("accessories-pdp-main__price-sale");
                priceElement.classList.add("accessories-pdp-main__price-regular");
            }
        }
        if (stockStatusElement) {
            if (variant.available) {
                stockStatusElement.innerHTML = '<span class="accessories-pdp-main__stock-in">' + labelInStock + "</span>";
            } else {
                stockStatusElement.innerHTML = '<span class="accessories-pdp-main__stock-out">' + labelOutOfStock + "</span>";
            }
        }
        if (addToCartBtn) {
            if (variant.available) {
                addToCartBtn.disabled = false;
                addToCartBtn.textContent = labelAdd;
            } else {
                addToCartBtn.disabled = true;
                addToCartBtn.textContent = labelSoldOut;
            }
        }
        if (variant.image) {
            updateMainImage(variant.image);
            updateThumbnailSelection(variant.image);
        } else if (variantData && variantData.featuredImage) {
            updateMainImage(variantData.featuredImage);
            updateThumbnailSelection(variantData.featuredImage);
        }
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", newUrl.toString());
        document.dispatchEvent(new CustomEvent("variant:changed", {
            detail: {
                variant: variant
            }
        }));
        console.log("[Accessories PDP] Variant updated:", variant.title, "ID:", variant.id);
    }
    function initVariantFromURL() {
        if (!variantData) return;
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get("variant");
        if (variantId) {
            const variant = variantData.variants.find(v => v.id === parseInt(variantId));
            if (variant) {
                variant.options.forEach((optionValue, index) => {
                    const input = document.querySelector(`.accessories-pdp-main__option-input[name="options[${variantData.options[index]}]"][value="${optionValue}"]`);
                    if (input) {
                        input.checked = true;
                    }
                });
                updateVariantUI(variant);
            }
        }
    }
    if (variantInputs.length && variantData) {
        variantInputs.forEach(input => {
            input.addEventListener("change", () => {
                const selectedOptions = getSelectedOptions();
                const variant = findVariantByOptions(selectedOptions);
                const optionGroup = input.closest(".accessories-pdp-main__option");
                const selectedColorLabel = optionGroup && optionGroup.querySelector(".accessories-pdp-main__selected-color");
                if (selectedColorLabel) {
                    selectedColorLabel.textContent = input.value;
                }
                if (variant) {
                    updateVariantUI(variant);
                } else {
                    console.warn("[Accessories PDP] No matching variant found for options:", selectedOptions);
                }
            });
        });
        initVariantFromURL();
    }
    const productForm = document.getElementById("productForm");
    if (productForm) {
        productForm.addEventListener("submit", async e => {
            e.preventDefault();
            const formData = new FormData(productForm);
            const variantId = formData.get("id");
            const quantity = parseInt(formData.get("quantity")) || 1;
            const submitButton = document.getElementById("addToCartBtn");
            if (submitButton) {
                submitButton.disabled = true;
                const originalText = submitButton.textContent;
                submitButton.textContent = labelAdding;
                try {
                    const response = await fetch("/cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json"
                        },
                        body: JSON.stringify({
                            id: variantId,
                            quantity: quantity,
                            sections: "cart-drawer-items,cart-header-dropdown"
                        })
                    });
                    if (!response.ok) {
                        throw new Error("Failed to add item to cart");
                    }
                    const data = await response.json();
                    console.log("[Accessories PDP] Item added to cart:", data);
                    if (window.cartDrawer && data.sections) {
                        window.cartDrawer.updateCartSections(data.sections);
                    }
                    document.dispatchEvent(new CustomEvent("cart:item:added", {
                        detail: {
                            item: data.items ? data.items[0] : data,
                            sections: data.sections
                        }
                    }));
                    submitButton.textContent = originalText;
                    submitButton.disabled = false;
                } catch (error) {
                    console.error("[Accessories PDP] Error adding to cart:", error);
                    alert("Sorry, there was an error adding this item to your cart. Please try again.");
                    submitButton.textContent = originalText;
                    submitButton.disabled = false;
                }
            }
        });
    }
    const enlargeBtn = document.getElementById("enlargeImageBtn");
    const zoomModal = document.getElementById("zoomModal");
    const zoomImage = document.getElementById("zoomImage");
    const zoomOverlay = document.querySelector(".accessories-pdp-main__zoom-overlay");
    const zoomCloseBtn = document.querySelector(".accessories-pdp-main__zoom-close");
    if (enlargeBtn && zoomModal && zoomImage && mainImage) {
        const openModal = () => {
            const currentImageSrc = mainImage.src;
            zoomImage.src = currentImageSrc;
            if (typeof gsap !== "undefined") {
                gsap.set(zoomModal, {
                    display: "flex"
                });
                gsap.fromTo(zoomModal, {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: .3,
                    ease: "power2.out"
                });
            } else {
                zoomModal.style.display = "flex";
                zoomModal.style.opacity = "1";
            }
            document.body.style.overflow = "hidden";
        };
        const closeModal = () => {
            if (typeof gsap !== "undefined") {
                gsap.to(zoomModal, {
                    opacity: 0,
                    duration: .3,
                    ease: "power2.in",
                    onComplete: () => {
                        gsap.set(zoomModal, {
                            display: "none"
                        });
                        zoomImage.src = "";
                    }
                });
            } else {
                zoomModal.style.display = "none";
                zoomImage.src = "";
            }
            document.body.style.overflow = "";
        };
        enlargeBtn.addEventListener("click", openModal);
        if (zoomCloseBtn) {
            zoomCloseBtn.addEventListener("click", closeModal);
        }
        if (zoomOverlay) {
            zoomOverlay.addEventListener("click", closeModal);
        }
        document.addEventListener("keydown", e => {
            if (e.key === "Escape" && zoomModal.style.display === "flex") {
                closeModal();
            }
        });
    }
    const redrillContainer = document.getElementById("redrillDropdownContainer");
    if (redrillContainer) {
        const redrillCta = document.getElementById("redrillCta");
        const selectedWay = () => redrillContainer.querySelector("[data-add-option]:checked");
        if (redrillCta) {
            redrillCta.addEventListener("click", () => {
                const chosen = selectedWay();
                if (chosen) handleRedrillOption(chosen.dataset.addOption);
            });
        }
        async function handleRedrillOption(choice) {
            const variantId = (document.getElementById("productVariantId") || {}).value || "";
            const handle = redrillContainer.dataset.productHandle || "";
            const redrillPrice = redrillContainer.dataset.productPrice || "";
            if (choice === "redrill-clip") {
                window.location.href = "/pages/order-flow?start=step3&mode=redrill" + "&redrillVariant=" + encodeURIComponent(variantId) + "&redrillHandle=" + encodeURIComponent(handle) + "&redrillPrice=" + encodeURIComponent(redrillPrice) + "&source=redrill-pdp";
                return;
            }
            const quantity = parseInt((document.getElementById("Quantity") || {}).value, 10) || 1;
            const btn = redrillCta;
            const originalText = btn ? btn.textContent.trim() : "";
            if (btn) {
                btn.disabled = true;
                btn.textContent = labelAdding;
            }
            const redrillProps = {
                "_Order Source": "Redrill - Replacement Magnets"
            };
            const selectedFinish = document.querySelector(".accessories-pdp-main__color-swatches .accessories-pdp-main__option-input:checked");
            if (selectedFinish && selectedFinish.value) {
                redrillProps["_Magnet Finish"] = selectedFinish.value;
            }
            try {
                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: quantity,
                        properties: redrillProps,
                        sections: "cart-drawer-items,cart-header-dropdown"
                    })
                });
                if (!response.ok) throw new Error("Failed to add item to cart");
                const data = await response.json();
                if (window.cartDrawer && data.sections) {
                    window.cartDrawer.updateCartSections(data.sections);
                }
                document.dispatchEvent(new CustomEvent("cart:item:added", {
                    detail: {
                        item: data.items ? data.items[0] : data,
                        sections: data.sections
                    }
                }));
                if (window.cartDrawer && typeof window.cartDrawer.openDrawer === "function") {
                    window.cartDrawer.openDrawer();
                }
            } catch (error) {
                console.error("[Redrill PDP] Error adding to cart:", error);
                alert("Sorry, there was an error adding this item to your cart. Please try again.");
            } finally {
                if (btn) {
                    btn.disabled = false;
                    btn.textContent = originalText;
                }
            }
        }
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    class AnnouncementBar {
    constructor(container) {
        this.container = container;
        this.barContainer = container.querySelector(".announcement-bar__container");
        this.messagesContainer = container.querySelector(".announcement-bar__messages");
        this.messages = container.querySelectorAll(".announcement-bar__message");
        this.indicators = container.querySelectorAll(".announcement-bar__indicator");
        this.prevButtons = container.querySelectorAll(".announcement-bar__arrow--prev");
        this.nextButtons = container.querySelectorAll(".announcement-bar__arrow--next");
        this.currentIndex = 0;
        this.isPlaying = this.messagesContainer.dataset.autoplay === "true";
        this.speed = parseInt(this.messagesContainer.dataset.speed) || 5e3;
        this.pauseOnHover = this.messagesContainer.dataset.pauseOnHover === "true";
        this.intervalId = null;
        this.isPaused = false;
        this.init();
    }
    init() {
        this.checkOverflow();
        window.addEventListener("resize", () => this.checkOverflow());
        if (this.messages.length <= 1) return;
        this.bindEvents();
        if (this.isPlaying) {
            this.startAutoplay();
        }
    }
    checkOverflow() {
        const textElements = this.container.querySelectorAll(".announcement-bar__text");
        textElements.forEach(text => {
            const parent = text.closest(".announcement-bar__content");
            if (parent) {
                const isOverflowing = text.scrollWidth > parent.clientWidth;
                if (isOverflowing) {
                    text.classList.add("overflow");
                } else {
                    text.classList.remove("overflow");
                }
            }
        });
    }
    bindEvents() {
        this.prevButtons.forEach(button => {
            button.addEventListener("click", e => {
                e.preventDefault();
                e.stopPropagation();
                this.goToPrevious();
            });
        });
        this.nextButtons.forEach(button => {
            button.addEventListener("click", e => {
                e.preventDefault();
                e.stopPropagation();
                this.goToNext();
            });
        });
        this.indicators.forEach((indicator, index) => {
            indicator.addEventListener("click", () => this.goToSlide(index));
        });
        if (this.pauseOnHover) {
            this.container.addEventListener("mouseenter", () => this.pause());
            this.container.addEventListener("mouseleave", () => this.resume());
        }
        this.container.addEventListener("keydown", e => {
            if (e.key === "ArrowLeft") {
                e.preventDefault();
                this.goToPrevious();
            } else if (e.key === "ArrowRight") {
                e.preventDefault();
                this.goToNext();
            }
        });
        document.addEventListener("shopify:block:select", e => {
            if (this.container.contains(e.target)) {
                const blockIndex = Array.from(this.messages).findIndex(msg => msg.dataset.blockId === e.target.dataset.blockId);
                if (blockIndex !== -1) {
                    this.pause();
                    this.goToSlide(blockIndex);
                }
            }
        });
        document.addEventListener("shopify:block:deselect", () => {
            if (this.isPlaying && !this.isPaused) {
                this.resume();
            }
        });
    }
    goToSlide(index) {
        if (index === this.currentIndex) return;
        this.messages[this.currentIndex].classList.remove("active");
        if (this.indicators[this.currentIndex]) {
            this.indicators[this.currentIndex].classList.remove("active");
        }
        this.currentIndex = index;
        this.messages[this.currentIndex].classList.add("active");
        if (this.indicators[this.currentIndex]) {
            this.indicators[this.currentIndex].classList.add("active");
        }
        this.announceSlideChange();
    }
    goToNext() {
        const nextIndex = (this.currentIndex + 1) % this.messages.length;
        this.goToSlide(nextIndex);
    }
    goToPrevious() {
        const prevIndex = (this.currentIndex - 1 + this.messages.length) % this.messages.length;
        this.goToSlide(prevIndex);
    }
    startAutoplay() {
        if (this.messages.length <= 1) return;
        this.intervalId = setInterval(() => {
            if (!this.isPaused) {
                this.goToNext();
            }
        }, this.speed);
    }
    stopAutoplay() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
    pause() {
        this.isPaused = true;
    }
    resume() {
        if (this.isPlaying) {
            this.isPaused = false;
        }
    }
    announceSlideChange() {
        const liveRegion = this.container.querySelector(".announcement-bar__live-region") || this.createLiveRegion();
        const currentMessage = this.messages[this.currentIndex];
        const messageText = currentMessage.querySelector(".announcement-bar__text").textContent;
        liveRegion.textContent = `Slide ${this.currentIndex + 1} of ${this.messages.length}: ${messageText}`;
    }
    createLiveRegion() {
        const liveRegion = document.createElement("div");
        liveRegion.className = "announcement-bar__live-region sr-only";
        liveRegion.setAttribute("aria-live", "polite");
        liveRegion.setAttribute("aria-atomic", "true");
        this.container.appendChild(liveRegion);
        return liveRegion;
    }
    destroy() {
        this.stopAutoplay();
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".announcement-bar").forEach(container => {
        new AnnouncementBar(container);
    });
});

document.addEventListener("shopify:section:load", e => {
    const announcementBar = e.target.querySelector(".announcement-bar");
    if (announcementBar) {
        new AnnouncementBar(announcementBar);
    }
});

document.addEventListener("shopify:section:unload", e => {
    const announcementBar = e.target.querySelector(".announcement-bar");
    if (announcementBar && announcementBar.announcementBarInstance) {
        announcementBar.announcementBarInstance.destroy();
    }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const tocContainer = document.querySelector("[data-article-toc]");
    const tocList = document.querySelector("[data-toc-list]");
    const tocToggle = document.querySelector("[data-toc-toggle]");
    const articleBody = document.querySelector(".article-body");
    if (!tocContainer || !tocList || !articleBody) return;
    const headings = articleBody.querySelectorAll("h2, h3");
    if (headings.length === 0) {
        tocContainer.style.display = "none";
        return;
    }
    headings.forEach((heading, index) => {
        if (!heading.id) {
            const id = "heading-" + (index + 1) + "-" + heading.textContent.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
            heading.id = id;
        }
        const li = document.createElement("li");
        li.className = "article-toc__item";
        if (heading.tagName.toLowerCase() === "h3") {
            li.classList.add("article-toc__item--h3");
        }
        const link = document.createElement("a");
        link.href = "#" + heading.id;
        link.className = "article-toc__link";
        link.textContent = heading.textContent;
        link.setAttribute("data-toc-link", "");
        li.appendChild(link);
        tocList.appendChild(li);
    });
    if (tocToggle) {
        tocToggle.addEventListener("click", function() {
            const isExpanded = this.getAttribute("aria-expanded") === "true";
            if (isExpanded) {
                this.setAttribute("aria-expanded", "false");
                tocList.setAttribute("hidden", "");
            } else {
                this.setAttribute("aria-expanded", "true");
                tocList.removeAttribute("hidden");
            }
        });
    }
    const tocLinks = tocList.querySelectorAll("[data-toc-link]");
    tocLinks.forEach(link => {
        link.addEventListener("click", function(e) {
            e.preventDefault();
            const targetId = this.getAttribute("href").substring(1);
            const targetHeading = document.getElementById(targetId);
            if (targetHeading) {
                const headerHeight = document.querySelector(".chemistrie-header")?.offsetHeight || 80;
                const offset = headerHeight + 20;
                const targetPosition = targetHeading.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({
                    top: targetPosition,
                    behavior: "smooth"
                });
                updateActiveTocLink(this);
            }
        });
    });
    let ticking = false;
    function updateActiveSectionOnScroll() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
                const headerHeight = document.querySelector(".chemistrie-header")?.offsetHeight || 80;
                const scrollPosition = window.scrollY + headerHeight + 50;
                let activeHeading = null;
                headings.forEach(heading => {
                    const headingTop = heading.offsetTop;
                    if (scrollPosition >= headingTop) {
                        activeHeading = heading;
                    }
                });
                if (activeHeading) {
                    const activeLink = tocList.querySelector(`[href="#${activeHeading.id}"]`);
                    updateActiveTocLink(activeLink);
                }
                ticking = false;
            });
            ticking = true;
        }
    }
    function updateActiveTocLink(activeLink) {
        tocLinks.forEach(link => link.classList.remove("is-active"));
        if (activeLink) {
            activeLink.classList.add("is-active");
        }
    }
    window.addEventListener("scroll", updateActiveSectionOnScroll, {
        passive: true
    });
    updateActiveSectionOnScroll();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    if (window.location.pathname === "/cart") {
    window.location.href = "/?open-cart=true";
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-pdp-hero-3d"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const PDPGallery = {
        elements: {
            mainImage: null,
            thumbnails: null
        },
        init() {
            if (typeof gsap === "undefined") {
                setTimeout(() => this.init(), 100);
                return;
            }
            this.cacheElements();
            this.attachEventListeners();
        },
        cacheElements() {
            this.elements.mainImage = document.getElementById("pdpMainImage");
            this.elements.thumbnails = document.querySelectorAll(".clips-pdp-hero__thumbnail");
        },
        attachEventListeners() {
            this.elements.thumbnails.forEach(thumb => {
                thumb.addEventListener("click", () => {
                    const imageSrc = thumb.getAttribute("data-image-src");
                    if (!imageSrc) return;
                    this.elements.thumbnails.forEach(t => t.classList.remove("active"));
                    thumb.classList.add("active");
                    this.animateImageChange(imageSrc);
                    gsap.fromTo(thumb, {
                        scale: .95
                    }, {
                        scale: 1,
                        duration: .3,
                        ease: "elastic.out(1, 0.5)"
                    });
                });
            });
        },
        animateImageChange(newSrc) {
            if (!this.elements.mainImage) return;
            gsap.to(this.elements.mainImage, {
                opacity: 0,
                scale: .98,
                duration: .3,
                ease: "power2.out",
                onComplete: () => {
                    this.elements.mainImage.src = newSrc;
                    gsap.to(this.elements.mainImage, {
                        opacity: 1,
                        scale: 1,
                        duration: .4,
                        ease: "power2.out"
                    });
                }
            });
        }
    };
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => PDPGallery.init());
    } else {
        PDPGallery.init();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-pdp-hero-bluelight"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const PDPGallery = {
        elements: {
            mainImage: null,
            thumbnails: null
        },
        init() {
            if (typeof gsap === "undefined") {
                setTimeout(() => this.init(), 100);
                return;
            }
            this.cacheElements();
            this.attachEventListeners();
        },
        cacheElements() {
            this.elements.mainImage = document.getElementById("pdpMainImage");
            this.elements.thumbnails = document.querySelectorAll(".clips-pdp-hero__thumbnail");
        },
        attachEventListeners() {
            this.elements.thumbnails.forEach(thumb => {
                thumb.addEventListener("click", () => {
                    const imageSrc = thumb.getAttribute("data-image-src");
                    if (!imageSrc) return;
                    this.elements.thumbnails.forEach(t => t.classList.remove("active"));
                    thumb.classList.add("active");
                    this.animateImageChange(imageSrc);
                    gsap.fromTo(thumb, {
                        scale: .95
                    }, {
                        scale: 1,
                        duration: .3,
                        ease: "elastic.out(1, 0.5)"
                    });
                });
            });
        },
        animateImageChange(newSrc) {
            if (!this.elements.mainImage) return;
            gsap.to(this.elements.mainImage, {
                opacity: 0,
                scale: .98,
                duration: .3,
                ease: "power2.out",
                onComplete: () => {
                    this.elements.mainImage.src = newSrc;
                    gsap.to(this.elements.mainImage, {
                        opacity: 1,
                        scale: 1,
                        duration: .4,
                        ease: "power2.out"
                    });
                }
            });
        }
    };
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => PDPGallery.init());
    } else {
        PDPGallery.init();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-pdp-hero-driving"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const PDPGallery = {
        elements: {
            mainImage: null,
            thumbnails: null
        },
        init() {
            if (typeof gsap === "undefined") {
                setTimeout(() => this.init(), 100);
                return;
            }
            this.cacheElements();
            this.attachEventListeners();
        },
        cacheElements() {
            this.elements.mainImage = document.getElementById("pdpMainImage");
            this.elements.thumbnails = document.querySelectorAll(".clips-pdp-hero__thumbnail");
        },
        attachEventListeners() {
            this.elements.thumbnails.forEach(thumb => {
                thumb.addEventListener("click", () => {
                    const imageSrc = thumb.getAttribute("data-image-src");
                    if (!imageSrc) return;
                    this.elements.thumbnails.forEach(t => t.classList.remove("active"));
                    thumb.classList.add("active");
                    this.animateImageChange(imageSrc);
                    gsap.fromTo(thumb, {
                        scale: .95
                    }, {
                        scale: 1,
                        duration: .3,
                        ease: "elastic.out(1, 0.5)"
                    });
                });
            });
        },
        animateImageChange(newSrc) {
            if (!this.elements.mainImage) return;
            gsap.to(this.elements.mainImage, {
                opacity: 0,
                scale: .98,
                duration: .3,
                ease: "power2.out",
                onComplete: () => {
                    this.elements.mainImage.src = newSrc;
                    gsap.to(this.elements.mainImage, {
                        opacity: 1,
                        scale: 1,
                        duration: .4,
                        ease: "power2.out"
                    });
                }
            });
        }
    };
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => PDPGallery.init());
    } else {
        PDPGallery.init();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-pdp-hero-light-sensitivity"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const PDPColorSystem = {
        colorData: {
            colors: [ "Light", "Medium" ],
            displayPrefix: "FL-41",
            hexColors: {
                Light: "#dfc8c5",
                Medium: "#df978f"
            }
        },
        imageTypes: [ "ClipOnly", "RaenAngle", "RaenFront", "RayBan", "Female", "Male" ],
        assetData: null,
        state: {
            currentColor: "Light",
            currentThumbnailIndex: 0,
            isAnimating: false
        },
        elements: {
            mainImage: null,
            thumbnails: null,
            lensColorSpec: null,
            colorGrid: null
        },
        init() {
            if (!document.querySelector(".clips-pdp-hero--light-sensitivity")) return;
            if (typeof gsap === "undefined") {
                setTimeout(() => this.init(), 100);
                return;
            }
            this.loadAssetData();
            if (!this.assetData) {
                console.error("PDP Color System: Asset data not found");
                return;
            }
            this.cacheElements();
            this.renderColorPicker();
            this.attachEventListeners();
            this.preloadImages();
        },
        loadAssetData() {
            const assetScript = document.getElementById("pdp-color-assets");
            if (assetScript) {
                try {
                    this.assetData = JSON.parse(assetScript.textContent);
                } catch (e) {
                    console.error("PDP Color System: Failed to parse asset data", e);
                }
            }
        },
        cacheElements() {
            this.elements.mainImage = document.getElementById("pdpMainImage");
            this.elements.thumbnails = document.querySelectorAll(".clips-pdp-hero--light-sensitivity .clips-pdp-hero__thumbnail");
            this.elements.lensColorSpec = document.querySelector(".clips-pdp-hero--light-sensitivity [data-spec-lens]");
            this.elements.colorGrid = document.getElementById("pdpColorGrid");
        },
        renderColorPicker() {
            if (!this.elements.colorGrid) return;
            this.elements.colorGrid.innerHTML = "";
            this.colorData.colors.forEach(colorName => {
                const puck = this.createColorPuck(colorName);
                this.elements.colorGrid.appendChild(puck);
            });
        },
        createColorPuck(colorName) {
            const puck = document.createElement("button");
            puck.className = "pdp-color-puck";
            puck.setAttribute("data-color", colorName);
            puck.setAttribute("aria-label", `Select FL-41 ${colorName} lens`);
            if (colorName === this.state.currentColor) {
                puck.classList.add("selected");
            }
            const hexColor = this.colorData.hexColors[colorName];
            const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "50");
            svg.setAttribute("height", "50");
            svg.setAttribute("viewBox", "0 0 50 50");
            const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            circle.setAttribute("cx", "25");
            circle.setAttribute("cy", "25");
            circle.setAttribute("r", "22");
            circle.setAttribute("fill", hexColor);
            circle.style.stroke = "var(--border)";
            circle.setAttribute("stroke-width", "2");
            svg.appendChild(circle);
            puck.appendChild(svg);
            const label = document.createElement("span");
            label.className = "pdp-color-puck__label";
            label.textContent = colorName;
            puck.appendChild(label);
            puck.addEventListener("click", () => {
                this.selectColor(colorName);
            });
            return puck;
        },
        selectColor(colorName) {
            if (this.state.isAnimating) return;
            this.state.currentColor = colorName;
            this.updateActivePuck(colorName);
            this.updateAllThumbnails();
            this.updateMainImage();
            this.updateProductSpecs();
        },
        updateActivePuck(colorName) {
            document.querySelectorAll(".clips-pdp-hero--light-sensitivity .pdp-color-puck").forEach(puck => {
                const puckColor = puck.getAttribute("data-color");
                if (puckColor === colorName) {
                    puck.classList.add("selected");
                } else {
                    puck.classList.remove("selected");
                }
            });
        },
        updateAllThumbnails() {
            this.elements.thumbnails.forEach((thumb, index) => {
                const imageType = this.imageTypes[index];
                const img = thumb.querySelector(".thumbnail-image");
                if (img) {
                    const newSrc = this.getImageURL(imageType);
                    this.animateImageChange(img, newSrc);
                }
            });
        },
        updateMainImage() {
            const activeThumbnail = document.querySelector(".clips-pdp-hero--light-sensitivity .clips-pdp-hero__thumbnail.active");
            if (!activeThumbnail) return;
            const imageType = activeThumbnail.getAttribute("data-image-type");
            const newSrc = this.getImageURL(imageType);
            this.animateImageChange(this.elements.mainImage, newSrc);
        },
        updateProductSpecs() {
            if (!this.elements.lensColorSpec) return;
            const lensText = `${this.colorData.displayPrefix} ${this.state.currentColor}`;
            this.elements.lensColorSpec.textContent = lensText;
        },
        animateImageChange(imgElement, newSrc) {
            if (!imgElement) return;
            this.state.isAnimating = true;
            gsap.to(imgElement, {
                opacity: 0,
                scale: .98,
                duration: .3,
                ease: "power2.out",
                onComplete: () => {
                    imgElement.src = newSrc;
                    gsap.to(imgElement, {
                        opacity: 1,
                        scale: 1,
                        duration: .4,
                        ease: "power2.out",
                        onComplete: () => {
                            this.state.isAnimating = false;
                        }
                    });
                }
            });
        },
        getImageURL(imageType) {
            return this.assetData.productImages[this.state.currentColor][imageType];
        },
        attachEventListeners() {
            this.elements.thumbnails.forEach((thumb, index) => {
                thumb.addEventListener("click", () => {
                    const imageType = thumb.getAttribute("data-image-type");
                    this.elements.thumbnails.forEach(t => t.classList.remove("active"));
                    thumb.classList.add("active");
                    this.state.currentThumbnailIndex = index;
                    const newSrc = this.getImageURL(imageType);
                    this.animateImageChange(this.elements.mainImage, newSrc);
                    gsap.fromTo(thumb, {
                        scale: .95
                    }, {
                        scale: 1,
                        duration: .3,
                        ease: "elastic.out(1, 0.5)"
                    });
                });
            });
        },
        preloadImages() {
            this.colorData.colors.forEach(colorName => {
                this.imageTypes.forEach(imageType => {
                    if (this.assetData.productImages[colorName]) {
                        const url = this.assetData.productImages[colorName][imageType];
                        const img = new Image;
                        img.src = url;
                    }
                });
            });
        }
    };
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => PDPColorSystem.init());
    } else {
        PDPColorSystem.init();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-pdp-hero-migraine"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const PDPMigraineGallery = {
        imageTypes: [ "ClipOnly", "RaenAngle", "RaenFront", "RayBan", "Female", "Male" ],
        assetData: null,
        state: {
            currentThumbnailIndex: 0,
            isAnimating: false
        },
        elements: {
            mainImage: null,
            thumbnails: null
        },
        init() {
            if (!document.querySelector(".clips-pdp-hero--migraine")) return;
            if (typeof gsap === "undefined") {
                setTimeout(() => this.init(), 100);
                return;
            }
            this.loadAssetData();
            if (!this.assetData) {
                console.error("PDP Migraine Gallery: Asset data not found");
                return;
            }
            this.cacheElements();
            this.attachEventListeners();
            this.preloadImages();
        },
        loadAssetData() {
            const assetScript = document.getElementById("pdp-migraine-assets");
            if (assetScript) {
                try {
                    this.assetData = JSON.parse(assetScript.textContent);
                } catch (e) {
                    console.error("PDP Migraine Gallery: Failed to parse asset data", e);
                }
            }
        },
        cacheElements() {
            this.elements.mainImage = document.getElementById("pdpMainImage");
            this.elements.thumbnails = document.querySelectorAll(".clips-pdp-hero--migraine .clips-pdp-hero__thumbnail");
        },
        animateImageChange(imgElement, newSrc) {
            if (!imgElement) return;
            this.state.isAnimating = true;
            gsap.to(imgElement, {
                opacity: 0,
                scale: .98,
                duration: .3,
                ease: "power2.out",
                onComplete: () => {
                    imgElement.src = newSrc;
                    gsap.to(imgElement, {
                        opacity: 1,
                        scale: 1,
                        duration: .4,
                        ease: "power2.out",
                        onComplete: () => {
                            this.state.isAnimating = false;
                        }
                    });
                }
            });
        },
        getImageURL(imageType) {
            return this.assetData.productImages[imageType];
        },
        attachEventListeners() {
            this.elements.thumbnails.forEach((thumb, index) => {
                thumb.addEventListener("click", () => {
                    if (this.state.isAnimating) return;
                    const imageType = thumb.getAttribute("data-image-type");
                    this.elements.thumbnails.forEach(t => t.classList.remove("active"));
                    thumb.classList.add("active");
                    this.state.currentThumbnailIndex = index;
                    const newSrc = this.getImageURL(imageType);
                    this.animateImageChange(this.elements.mainImage, newSrc);
                    gsap.fromTo(thumb, {
                        scale: .95
                    }, {
                        scale: 1,
                        duration: .3,
                        ease: "elastic.out(1, 0.5)"
                    });
                });
            });
        },
        preloadImages() {
            this.imageTypes.forEach(imageType => {
                const url = this.assetData.productImages[imageType];
                const img = new Image;
                img.src = url;
            });
        }
    };
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => PDPMigraineGallery.init());
    } else {
        PDPMigraineGallery.init();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-pdp-hero-reader"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const PDPGallery = {
        elements: {
            mainImage: null,
            thumbnails: null
        },
        init() {
            if (typeof gsap === "undefined") {
                setTimeout(() => this.init(), 100);
                return;
            }
            this.cacheElements();
            this.attachEventListeners();
        },
        cacheElements() {
            this.elements.mainImage = document.getElementById("pdpMainImage");
            this.elements.thumbnails = document.querySelectorAll(".clips-pdp-hero__thumbnail");
        },
        attachEventListeners() {
            this.elements.thumbnails.forEach(thumb => {
                thumb.addEventListener("click", () => {
                    const imageSrc = thumb.getAttribute("data-image-src");
                    if (!imageSrc) return;
                    this.elements.thumbnails.forEach(t => t.classList.remove("active"));
                    thumb.classList.add("active");
                    this.animateImageChange(imageSrc);
                    gsap.fromTo(thumb, {
                        scale: .95
                    }, {
                        scale: 1,
                        duration: .3,
                        ease: "elastic.out(1, 0.5)"
                    });
                });
            });
        },
        animateImageChange(newSrc) {
            if (!this.elements.mainImage) return;
            gsap.to(this.elements.mainImage, {
                opacity: 0,
                scale: .98,
                duration: .3,
                ease: "power2.out",
                onComplete: () => {
                    this.elements.mainImage.src = newSrc;
                    gsap.to(this.elements.mainImage, {
                        opacity: 1,
                        scale: 1,
                        duration: .4,
                        ease: "power2.out"
                    });
                }
            });
        }
    };
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => PDPGallery.init());
    } else {
        PDPGallery.init();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-pdp-hero"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const PDPColorSystem = {
        colorData: {
            gradient: {
                colors: [ "Amber", "CrimsonGrey", "DarkBrown", "DarkGrey", "MediumBrown", "Rouge", "VioletGrey", "VioletRose" ],
                displayPrefix: "Gradient"
            },
            mirror: {
                colors: [ "Blue", "Caliente", "Gold", "Green", "Morado", "Orange", "Silver", "SkyBlue" ],
                displayPrefix: "Mirror"
            },
            solid: {
                colors: [ "Amber", "Blue", "Bronze", "Brown", "G15", "Grey", "Rose", "Yellow" ],
                displayPrefix: "Solid"
            },
            "non-polarized": {
                colors: [ "Grey", "Brown", "G15" ],
                displayPrefix: "NP",
                displayNames: {
                    Grey: "NP Grey",
                    Brown: "NP Brown",
                    G15: "NP G-15"
                }
            }
        },
        imageTypes: [ "ClipOnly", "RaenAngle", "RaenFront", "RayBan", "Female", "Male" ],
        assetData: null,
        state: {
            currentCategory: "gradient",
            currentColor: "Amber",
            currentThumbnailIndex: 0,
            isAnimating: false
        },
        elements: {
            mainImage: null,
            thumbnails: null,
            lensColorSpec: null,
            colorGrid: null,
            categoryTabs: null
        },
        init() {
            if (typeof gsap === "undefined") {
                setTimeout(() => this.init(), 100);
                return;
            }
            this.loadAssetData();
            if (!this.assetData) {
                console.error("PDP Color System: Asset data not found");
                return;
            }
            this.cacheElements();
            this.renderColorPicker();
            this.attachEventListeners();
            this.preloadImages();
        },
        loadAssetData() {
            const assetScript = document.getElementById("pdp-color-assets");
            if (assetScript) {
                try {
                    this.assetData = JSON.parse(assetScript.textContent);
                } catch (e) {
                    console.error("PDP Color System: Failed to parse asset data", e);
                }
            }
        },
        cacheElements() {
            this.elements.mainImage = document.getElementById("pdpMainImage");
            this.elements.thumbnails = document.querySelectorAll(".clips-pdp-hero__thumbnail");
            this.elements.lensColorSpec = document.querySelector("[data-spec-lens]");
            this.elements.colorGrid = document.getElementById("pdpColorGrid");
            this.elements.categoryTabs = document.querySelectorAll(".pdp-category-tab");
        },
        renderColorPicker() {
            if (!this.elements.colorGrid) return;
            this.renderCategoryColors(this.state.currentCategory);
        },
        renderCategoryColors(category) {
            const categoryData = this.colorData[category];
            if (!categoryData) return;
            const colorGrid = this.elements.colorGrid;
            colorGrid.innerHTML = "";
            categoryData.colors.forEach(colorName => {
                const puck = this.createColorPuck(category, colorName);
                colorGrid.appendChild(puck);
            });
        },
        createColorPuck(category, colorName) {
            const puck = document.createElement("button");
            puck.className = "pdp-color-puck";
            puck.setAttribute("data-category", category);
            puck.setAttribute("data-color", colorName);
            puck.setAttribute("aria-label", `Select ${this.formatColorDisplay(category, colorName)} lens`);
            if (category === this.state.currentCategory && colorName === this.state.currentColor) {
                puck.classList.add("selected");
            }
            const puckSrc = this.assetData.colorPucks[category][colorName];
            const img = document.createElement("img");
            img.src = puckSrc;
            img.alt = this.formatColorDisplay(category, colorName);
            puck.appendChild(img);
            const label = document.createElement("span");
            label.className = "pdp-color-puck__label";
            label.textContent = this.colorData[category].displayNames && this.colorData[category].displayNames[colorName] ? this.colorData[category].displayNames[colorName] : colorName.replace(/([A-Z])/g, " $1").trim();
            puck.appendChild(label);
            puck.addEventListener("click", () => {
                this.selectColor(category, colorName);
            });
            return puck;
        },
        selectColor(category, colorName) {
            if (this.state.isAnimating) return;
            this.state.currentCategory = category;
            this.state.currentColor = colorName;
            this.updateActivePuck(category, colorName);
            this.updateAllThumbnails();
            this.updateMainImage();
            this.updateProductSpecs();
        },
        updateActivePuck(category, colorName) {
            document.querySelectorAll(".pdp-color-puck").forEach(puck => {
                const puckCategory = puck.getAttribute("data-category");
                const puckColor = puck.getAttribute("data-color");
                if (puckCategory === category && puckColor === colorName) {
                    puck.classList.add("selected");
                } else {
                    puck.classList.remove("selected");
                }
            });
        },
        updateAllThumbnails() {
            this.elements.thumbnails.forEach((thumb, index) => {
                const imageType = this.imageTypes[index];
                const img = thumb.querySelector(".thumbnail-image");
                if (img) {
                    const newSrc = this.getImageURL(imageType);
                    this.animateImageChange(img, newSrc);
                }
            });
        },
        updateMainImage() {
            const activeThumbnail = document.querySelector(".clips-pdp-hero__thumbnail.active");
            if (!activeThumbnail) return;
            const imageType = activeThumbnail.getAttribute("data-image-type");
            const newSrc = this.getImageURL(imageType);
            this.animateImageChange(this.elements.mainImage, newSrc);
        },
        updateProductSpecs() {
            if (!this.elements.lensColorSpec) return;
            let lensText = this.formatColorDisplay(this.state.currentCategory, this.state.currentColor);
            this.elements.lensColorSpec.textContent = lensText;
        },
        animateImageChange(imgElement, newSrc) {
            if (!imgElement) return;
            this.state.isAnimating = true;
            gsap.to(imgElement, {
                opacity: 0,
                scale: .98,
                duration: .3,
                ease: "power2.out",
                onComplete: () => {
                    imgElement.src = newSrc;
                    gsap.to(imgElement, {
                        opacity: 1,
                        scale: 1,
                        duration: .4,
                        ease: "power2.out",
                        onComplete: () => {
                            this.state.isAnimating = false;
                        }
                    });
                }
            });
        },
        getImageURL(imageType) {
            return this.assetData.productImages[this.state.currentCategory][this.state.currentColor][imageType];
        },
        attachEventListeners() {
            this.elements.categoryTabs.forEach(tab => {
                tab.addEventListener("click", () => {
                    const category = tab.getAttribute("data-category");
                    this.switchCategory(category);
                });
            });
            this.elements.thumbnails.forEach((thumb, index) => {
                thumb.addEventListener("click", () => {
                    const imageType = thumb.getAttribute("data-image-type");
                    this.elements.thumbnails.forEach(t => t.classList.remove("active"));
                    thumb.classList.add("active");
                    this.state.currentThumbnailIndex = index;
                    const newSrc = this.getImageURL(imageType);
                    this.animateImageChange(this.elements.mainImage, newSrc);
                    gsap.fromTo(thumb, {
                        scale: .95
                    }, {
                        scale: 1,
                        duration: .3,
                        ease: "elastic.out(1, 0.5)"
                    });
                });
            });
        },
        switchCategory(category) {
            this.elements.categoryTabs.forEach(tab => {
                if (tab.getAttribute("data-category") === category) {
                    tab.classList.add("active");
                } else {
                    tab.classList.remove("active");
                }
            });
            this.renderCategoryColors(category);
        },
        preloadImages() {
            Object.keys(this.colorData).forEach(category => {
                this.colorData[category].colors.forEach(colorName => {
                    this.imageTypes.forEach(imageType => {
                        if (this.assetData.productImages[category] && this.assetData.productImages[category][colorName]) {
                            const url = this.assetData.productImages[category][colorName][imageType];
                            const img = new Image;
                            img.src = url;
                        }
                    });
                });
            });
        },
        formatColorDisplay(category, colorName) {
            const categoryData = this.colorData[category];
            if (categoryData.displayNames && categoryData.displayNames[colorName]) {
                return categoryData.displayNames[colorName];
            }
            const prefix = categoryData.displayPrefix;
            const formattedColor = colorName.replace(/([A-Z])/g, " $1").trim();
            return `${prefix} ${formattedColor}`;
        }
    };
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => PDPColorSystem.init());
    } else {
        PDPColorSystem.init();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-plp-chooser"]) return;
  try {
    (function() {
    function initChooser(root) {
        if (root.dataset.chooserReady) return;
        root.dataset.chooserReady = "true";
        var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-clip-tab]"));
        var panels = Array.prototype.slice.call(root.querySelectorAll("[data-clip-panel]"));
        var dots = Array.prototype.slice.call(root.querySelectorAll("[data-clip-dot]"));
        var prev = root.querySelector("[data-clip-prev]");
        var next = root.querySelector("[data-clip-next]");
        var pick = root.querySelector("[data-clip-pick]");
        var pickValue = root.querySelector("[data-clip-pick-value]");
        var rail = root.querySelector(".clip-chooser__rail");
        if (!tabs.length || !panels.length) return;
        var order = tabs.map(function(t) {
            return t.getAttribute("data-clip-tab");
        });
        function current() {
            for (var i = 0; i < panels.length; i++) {
                if (panels[i].classList.contains("is-active")) {
                    return order.indexOf(panels[i].getAttribute("data-clip-panel"));
                }
            }
            return 0;
        }
        function show(key) {
            tabs.forEach(function(t) {
                var on = t.getAttribute("data-clip-tab") === key;
                t.classList.toggle("is-active", on);
                t.setAttribute("aria-selected", String(on));
            });
            panels.forEach(function(p) {
                p.classList.toggle("is-active", p.getAttribute("data-clip-panel") === key);
            });
            dots.forEach(function(d) {
                d.classList.toggle("is-active", d.getAttribute("data-clip-dot") === key);
            });
            if (pickValue) {
                var on = tabs.filter(function(t) {
                    return t.getAttribute("data-clip-tab") === key;
                })[0];
                var name = on && on.querySelector(".clip-chooser__need-name");
                if (name) pickValue.textContent = name.textContent;
            }
            closeRail();
        }
        function closeRail() {
            if (!rail || !pick) return;
            rail.classList.remove("is-open");
            pick.setAttribute("aria-expanded", "false");
        }
        function step(delta) {
            var i = (current() + delta + order.length) % order.length;
            show(order[i]);
        }
        tabs.forEach(function(t) {
            t.addEventListener("click", function() {
                show(t.getAttribute("data-clip-tab"));
            });
        });
        (function() {
            for (var i = 0; i < panels.length; i++) {
                if (panels[i].classList.contains("is-active")) {
                    var k = panels[i].getAttribute("data-clip-panel");
                    var on = tabs.filter(function(t) {
                        return t.getAttribute("data-clip-tab") === k;
                    })[0];
                    var nm = on && on.querySelector(".clip-chooser__need-name");
                    if (nm && pickValue) pickValue.textContent = nm.textContent;
                    return;
                }
            }
        })();
        if (prev) prev.addEventListener("click", function() {
            step(-1);
        });
        if (next) next.addEventListener("click", function() {
            step(1);
        });
        if (pick) {
            pick.addEventListener("click", function() {
                var open = rail.classList.toggle("is-open");
                pick.setAttribute("aria-expanded", String(open));
            });
        }
        root.addEventListener("keydown", function(e) {
            if (e.target.hasAttribute && e.target.hasAttribute("data-clip-tab")) {
                if (e.key === "ArrowRight") {
                    e.preventDefault();
                    step(1);
                }
                if (e.key === "ArrowLeft") {
                    e.preventDefault();
                    step(-1);
                }
            }
        });
    }
    function initAll() {
        document.querySelectorAll(".clip-chooser").forEach(initChooser);
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initAll);
    } else {
        initAll();
    }
    document.addEventListener("shopify:section:load", initAll);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clips-summary"] && !Shopify.designMode) return;
  try {
    (function() {
    function playVideo(v) {
        if (!v.dataset.loaded) {
            v.dataset.loaded = "1";
            v.muted = true;
            v.defaultMuted = true;
            v.playsInline = true;
            if (!v.getAttribute("src") && v.dataset.src) {
                v.src = v.dataset.src;
            }
            v.load();
        }
        var p = v.play();
        if (p && p.catch) {
            p.catch(function() {});
        }
    }
    function ensureObserver() {
        if (!window.__chemInviewIO) {
            if ("IntersectionObserver" in window) {
                window.__chemInviewIO = new IntersectionObserver(function(entries) {
                    entries.forEach(function(e) {
                        if (e.isIntersecting) {
                            playVideo(e.target);
                        } else if (!e.target.paused) {
                            e.target.pause();
                        }
                    });
                }, {
                    rootMargin: "200px 0px"
                });
            } else {
                window.__chemInviewIO = {
                    observe: function(v) {
                        playVideo(v);
                    }
                };
            }
        }
        document.querySelectorAll("[data-inview-video]:not([data-observed])").forEach(function(v) {
            v.setAttribute("data-observed", "1");
            window.__chemInviewIO.observe(v);
        });
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", ensureObserver);
    } else {
        ensureObserver();
    }
    document.addEventListener("shopify:section:load", ensureObserver);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-faq-links"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const faqLinkCards = document.querySelectorAll('.faq-link-card[data-action="faq-search"]');
    faqLinkCards.forEach(card => {
        card.addEventListener("click", function(e) {
            e.preventDefault();
            const searchQuery = this.dataset.search;
            const faqUrl = this.dataset.faqUrl || "/pages/faq";
            if (searchQuery) {
                window.location.href = `${faqUrl}?search=${encodeURIComponent(searchQuery)}`;
            }
        });
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-help-categories"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const helpCategoryCards = document.querySelectorAll(".help-category-card[data-action]");
    helpCategoryCards.forEach(card => {
        card.addEventListener("click", function(e) {
            const action = this.dataset.action;
            switch (action) {
              case "faq-search":
                const searchQuery = this.dataset.search;
                const faqUrl = this.dataset.faqUrl || "/pages/faq";
                window.location.href = `${faqUrl}?search=${encodeURIComponent(searchQuery)}`;
                break;

              case "faq-category":
                const category = this.dataset.category;
                const faqCategoryUrl = this.dataset.faqUrl || "/pages/faq";
                window.location.href = `${faqCategoryUrl}?category=${encodeURIComponent(category)}`;
                break;

              case "contact-form":
                const subject = this.dataset.subject;
                scrollToContactForm(subject);
                break;
            }
        });
    });
    function scrollToContactForm(subject) {
        const contactFormSection = document.querySelector(".contact-form-locator") || document.querySelector(".contact-form-section");
        const subjectSelect = document.getElementById("contact-subject");
        if (contactFormSection) {
            const rect = contactFormSection.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            let headerOffset = 0;
            const stickyHeader = document.querySelector(".chemistrie-header.is-sticky");
            const announcementBar = document.querySelector(".announcement-bar");
            const regularHeader = document.querySelector(".chemistrie-header");
            if (stickyHeader || regularHeader) {
                headerOffset = announcementBar ? 120 : 84;
            }
            const targetPosition = rect.top + scrollTop - headerOffset - 20;
            window.scrollTo({
                top: Math.max(0, targetPosition),
                behavior: "smooth"
            });
            if (subjectSelect && subject) {
                setTimeout(() => {
                    const options = subjectSelect.options;
                    for (let i = 0; i < options.length; i++) {
                        if (options[i].value === subject) {
                            subjectSelect.selectedIndex = i;
                            subjectSelect.dispatchEvent(new Event("change", {
                                bubbles: true
                            }));
                            break;
                        }
                    }
                    const formWrapper = contactFormSection.querySelector(".contact-form-locator__form-wrapper") || contactFormSection.querySelector(".contact-form__wrapper");
                    if (formWrapper) {
                        formWrapper.classList.add("contact-form-locator--highlighted", "contact-form--highlighted");
                        setTimeout(() => {
                            formWrapper.classList.remove("contact-form-locator--highlighted", "contact-form--highlighted");
                        }, 2e3);
                    }
                    const nameInput = document.getElementById("contact-name");
                    if (nameInput && !nameInput.value) {
                        nameInput.focus();
                    }
                }, 500);
            }
            console.log("Contact Help: Scrolled to form with subject:", subject);
        } else {
            console.warn("Contact Help: Contact form section not found");
        }
    }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crystal-pdp-main"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    var root = document.querySelector(".crystal-pdp");
    if (!root) return;
    var dataEl = document.getElementById("crystalPdpVariantData");
    if (!dataEl) return;
    var data;
    try {
        data = JSON.parse(dataEl.textContent);
    } catch (e) {
        console.error("[Crystal PDP] Could not parse variant data:", e);
        return;
    }
    var variants = data.variants || [];
    var moneyFormat = (data.moneyFormat || "").replace(/<[^>]*>/g, "");
    var hero = document.getElementById("crystalPdpHero");
    var overlay = document.getElementById("crystalPdpOverlay");
    var thumbOverlay = document.getElementById("crystalPdpThumbOverlay");
    var photo = document.getElementById("crystalPdpPhoto");
    var variantThumb = document.getElementById("crystalPdpVariantThumb");
    var variantThumbImg = document.getElementById("crystalPdpVariantThumbImg");
    var variantIdInput = document.getElementById("crystalPdpVariantId");
    var priceValue = document.getElementById("crystalPdpPriceValue");
    var priceCompare = document.getElementById("crystalPdpPriceCompare");
    var priceBadge = document.getElementById("crystalPdpPriceBadge");
    var addBtn = document.getElementById("crystalPdpAddBtn");
    var form = document.getElementById("crystalPdpForm");
    var optionInputs = root.querySelectorAll(".crystal-pdp__swatch-input");
    var thumbs = root.querySelectorAll(".crystal-pdp__thumb");
    var addBtnLabel = root.getAttribute("data-add-label") || "Add to Cart";
    var soldOutLabel = root.getAttribute("data-sold-out-label") || "Sold Out";
    var addingLabel = root.getAttribute("data-adding-label") || "Adding...";
    function formatMoney(cents) {
        var value = (cents / 100).toFixed(2);
        var parts = value.split(".");
        var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (!moneyFormat) return "$" + withCommas + "." + parts[1];
        return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function(match, token) {
            switch (token) {
              case "amount":
                return withCommas + "." + parts[1];

              case "amount_no_decimals":
                return withCommas;

              case "amount_with_comma_separator":
                return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "," + parts[1];

              case "amount_no_decimals_with_comma_separator":
                return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

              default:
                return match;
            }
        });
    }
    function getSelectedOptions() {
        var selected = [];
        optionInputs.forEach(function(input) {
            if (input.checked) {
                var position = parseInt(input.dataset.optionPosition, 10) || 1;
                selected[position - 1] = input.value;
            }
        });
        return selected;
    }
    function findVariant(selected) {
        for (var i = 0; i < variants.length; i++) {
            var match = true;
            for (var j = 0; j < selected.length; j++) {
                if (variants[i].options[j] !== selected[j]) {
                    match = false;
                    break;
                }
            }
            if (match) return variants[i];
        }
        return null;
    }
    function setActiveThumb(target) {
        thumbs.forEach(function(t) {
            t.classList.remove("active");
        });
        if (target) target.classList.add("active");
    }
    function showPreview() {
        if (hero) hero.classList.remove("crystal-pdp__hero--photo");
    }
    function showPhoto(url, alt) {
        if (!photo || !url) return;
        if (typeof gsap !== "undefined" && hero && hero.classList.contains("crystal-pdp__hero--photo")) {
            gsap.to(photo, {
                opacity: 0,
                duration: .2,
                onComplete: function() {
                    photo.src = url;
                    photo.alt = alt || "";
                    gsap.to(photo, {
                        opacity: 1,
                        duration: .3
                    });
                }
            });
        } else {
            photo.src = url;
            photo.alt = alt || "";
            if (hero) hero.classList.add("crystal-pdp__hero--photo");
        }
    }
    thumbs.forEach(function(thumb) {
        thumb.addEventListener("click", function() {
            setActiveThumb(thumb);
            var view = thumb.dataset.view;
            if (view === "preview") {
                showPreview();
            } else if (view === "variant") {
                var current = findVariant(getSelectedOptions());
                showPhoto(current && current.image, "");
            } else {
                showPhoto(thumb.dataset.imageUrl, thumb.querySelector("img") ? thumb.querySelector("img").alt : "");
            }
        });
    });
    var zoomOverlayLayer = document.getElementById("crystalPdpZoomOverlayLayer");
    function updateOverlay(input) {
        var src = input && input.dataset ? input.dataset.overlay : null;
        if (!src) return;
        if (overlay) overlay.src = src;
        if (thumbOverlay) thumbOverlay.src = src;
        if (zoomOverlayLayer) zoomOverlayLayer.src = src;
    }
    function updateSelectedLabel(input) {
        var position = input.dataset.optionPosition;
        var label = root.querySelector('.crystal-pdp__option-selected[data-option-position="' + position + '"]');
        if (label) label.textContent = input.value;
    }
    function updateVariantUI(variant) {
        if (!variant) return;
        if (variantIdInput) variantIdInput.value = variant.id;
        if (priceValue) priceValue.textContent = formatMoney(variant.price);
        var onSale = variant.compareAtPrice && variant.compareAtPrice > variant.price;
        if (priceCompare) {
            priceCompare.textContent = onSale ? formatMoney(variant.compareAtPrice) : "";
            priceCompare.hidden = !onSale;
        }
        if (priceBadge) priceBadge.hidden = !onSale;
        if (addBtn) {
            addBtn.disabled = !variant.available;
            addBtn.textContent = variant.available ? addBtnLabel : soldOutLabel;
        }
        var stockEl = document.getElementById("crystalPdpStock");
        if (stockEl) {
            stockEl.innerHTML = variant.available ? '<span class="crystal-pdp__stock-in">' + (root.getAttribute("data-in-stock-label") || "In Stock") + "</span>" : '<span class="crystal-pdp__stock-out">' + (root.getAttribute("data-out-stock-label") || "Out of Stock") + "</span>";
        }
        var installments = document.querySelector("shopify-payment-terms");
        if (installments) installments.setAttribute("variant-id", variant.id);
        var wasViewingVariantPhoto = variantThumb && variantThumb.classList.contains("active");
        if (variantThumb) {
            if (variant.thumb) {
                variantThumb.hidden = false;
                if (variantThumbImg) variantThumbImg.src = variant.thumb;
                if (wasViewingVariantPhoto) showPhoto(variant.image, "");
            } else {
                variantThumb.hidden = true;
                if (wasViewingVariantPhoto) {
                    var previewThumb = root.querySelector(".crystal-pdp__thumb--preview");
                    setActiveThumb(previewThumb);
                    showPreview();
                }
            }
        }
        if (window.history && window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set("variant", variant.id);
            window.history.replaceState({}, "", url.toString());
        }
    }
    optionInputs.forEach(function(input) {
        input.addEventListener("change", function() {
            updateSelectedLabel(input);
            updateOverlay(input);
            updateVariantUI(findVariant(getSelectedOptions()));
        });
    });
    var enlargeBtn = document.getElementById("crystalPdpEnlargeBtn");
    var zoomModal = document.getElementById("crystalPdpZoomModal");
    var zoomImage = document.getElementById("crystalPdpZoomImage");
    var zoomOverlayEl = document.getElementById("crystalPdpZoomOverlay");
    var zoomCloseBtn = document.getElementById("crystalPdpZoomClose");
    function openZoom() {
        if (!zoomModal) return;
        var showingPhoto = hero && hero.classList.contains("crystal-pdp__hero--photo");
        zoomModal.classList.toggle("crystal-pdp__zoom-modal--photo", !!showingPhoto);
        zoomModal.classList.toggle("crystal-pdp__zoom-modal--preview", !showingPhoto);
        if (showingPhoto && zoomImage && photo) {
            zoomImage.src = photo.src;
            zoomImage.alt = photo.alt || "";
        }
        zoomModal.classList.add("active");
        zoomModal.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";
        if (typeof gsap !== "undefined") {
            gsap.fromTo(zoomModal, {
                opacity: 0
            }, {
                opacity: 1,
                duration: .3
            });
        } else {
            zoomModal.style.opacity = "1";
        }
    }
    function closeZoom() {
        if (!zoomModal) return;
        var finish = function() {
            zoomModal.classList.remove("active");
            zoomModal.setAttribute("aria-hidden", "true");
            document.body.style.overflow = "";
        };
        if (typeof gsap !== "undefined") {
            gsap.to(zoomModal, {
                opacity: 0,
                duration: .25,
                onComplete: finish
            });
        } else {
            zoomModal.style.opacity = "0";
            finish();
        }
    }
    if (enlargeBtn) enlargeBtn.addEventListener("click", openZoom);
    if (zoomCloseBtn) zoomCloseBtn.addEventListener("click", closeZoom);
    if (zoomOverlayEl) zoomOverlayEl.addEventListener("click", closeZoom);
    document.addEventListener("keydown", function(e) {
        if (e.key === "Escape" && zoomModal && zoomModal.classList.contains("active")) {
            closeZoom();
        }
    });
    var qtyInput = document.getElementById("CrystalQuantity");
    root.querySelectorAll(".crystal-pdp__quantity-btn").forEach(function(btn) {
        btn.addEventListener("click", function() {
            if (!qtyInput) return;
            var current = parseInt(qtyInput.value, 10) || 1;
            var next = btn.dataset.action === "increase" ? current + 1 : current - 1;
            qtyInput.value = next < 1 ? 1 : next;
        });
    });
    if (form) {
        form.addEventListener("submit", async function(e) {
            e.preventDefault();
            if (!addBtn || addBtn.disabled) return;
            var original = addBtn.textContent;
            addBtn.disabled = true;
            addBtn.textContent = addingLabel;
            try {
                var response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    },
                    body: JSON.stringify({
                        id: variantIdInput ? variantIdInput.value : null,
                        quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1,
                        sections: "cart-drawer-items,cart-header-dropdown"
                    })
                });
                if (!response.ok) throw new Error("Add to cart failed with status " + response.status);
                var result = await response.json();
                if (window.cartDrawer && result.sections) {
                    window.cartDrawer.updateCartSections(result.sections);
                }
                document.dispatchEvent(new CustomEvent("cart:item:added", {
                    detail: {
                        item: result.items ? result.items[0] : result,
                        sections: result.sections
                    }
                }));
                if (window.cartDrawer && typeof window.cartDrawer.openDrawer === "function") {
                    window.cartDrawer.openDrawer();
                }
            } catch (error) {
                console.error("[Crystal PDP] Error adding to cart:", error);
                alert("Sorry, there was an error adding this item to your cart. Please try again.");
            } finally {
                addBtn.disabled = false;
                addBtn.textContent = original;
            }
        });
    }
    var checked = root.querySelector(".crystal-pdp__swatch-input[data-overlay]:checked");
    if (checked) updateOverlay(checked);
    root.querySelectorAll(".crystal-pdp__swatch-input[data-overlay]").forEach(function(input) {
        var img = new Image;
        img.src = input.dataset.overlay;
    });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eyeglasses-clip-ready"] && !Shopify.designMode) return;
  try {
    (function() {
    function bind() {
        var cta = document.getElementById("egClipReadyCta");
        if (!cta) return;
        cta.addEventListener("click", function() {
            var input = document.getElementById("productVariantId");
            if (!input || !input.value) return;
            var id = parseInt(input.value, 10);
            if (!id) return;
            var url;
            try {
                url = new URL(cta.getAttribute("href"), window.location.origin);
            } catch (e) {
                return;
            }
            url.searchParams.set("variant", String(id));
            var title = "";
            var data = document.getElementById("productVariantData");
            if (data) {
                try {
                    var parsed = JSON.parse(data.textContent);
                    var match = (parsed.variants || []).find(function(v) {
                        return v.id === id;
                    });
                    if (match && match.title) title = match.title;
                } catch (e) {}
            }
            if (title) url.searchParams.set("variantTitle", title);
            cta.setAttribute("href", url.pathname + url.search);
        });
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", bind);
    } else {
        bind();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eyeglasses-pdp-main"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const ROOT = document.querySelector(".eyeglasses-pdp-main");
    const CTA_LABEL = ROOT ? ROOT.dataset.ctaLabel || "" : "";
    const SOLD_OUT_LABEL = ROOT ? ROOT.dataset.soldOutLabel || "" : "";
    const FROM_TEMPLATE = ROOT ? ROOT.dataset.fromTemplate || "__P__" : "__P__";
    const CLIP_FROM_CENTS = ROOT ? parseInt(ROOT.dataset.clipFromCents || "0", 10) : 0;
    const thumbnails = document.querySelectorAll(".eyeglasses-pdp-main__thumbnail");
    const mainImage = document.getElementById("mainProductImage");
    if (thumbnails.length && mainImage) {
        thumbnails.forEach(thumbnail => {
            thumbnail.addEventListener("click", function() {
                thumbnails.forEach(t => t.classList.remove("active"));
                this.classList.add("active");
                const newImageUrl = this.getAttribute("data-image-url");
                if (newImageUrl && typeof gsap !== "undefined") {
                    gsap.to(mainImage, {
                        opacity: 0,
                        duration: .2,
                        onComplete: () => {
                            mainImage.src = newImageUrl;
                            gsap.to(mainImage, {
                                opacity: 1,
                                duration: .3
                            });
                        }
                    });
                } else if (newImageUrl) {
                    mainImage.src = newImageUrl;
                }
            });
        });
    }
    const variantInputs = document.querySelectorAll(".eyeglasses-pdp-main__option-input");
    const variantDataElement = document.getElementById("productVariantData");
    const variantIdInput = document.getElementById("productVariantId");
    const priceElement = document.getElementById("priceValue");
    const stockStatusElement = document.getElementById("stockStatus");
    const mainImageEl = document.getElementById("mainProductImage");
    let variantData = null;
    if (variantDataElement) {
        try {
            variantData = JSON.parse(variantDataElement.textContent);
        } catch (e) {
            console.error("Failed to parse variant data:", e);
        }
    }
    function findVariantByOptions(selectedOptions) {
        if (!variantData || !variantData.variants) return null;
        return variantData.variants.find(variant => selectedOptions.every((option, index) => variant.options[index] === option));
    }
    function getSelectedOptions() {
        const options = [];
        const optionGroups = document.querySelectorAll(".eyeglasses-pdp-main__option");
        optionGroups.forEach(group => {
            const checkedInput = group.querySelector(".eyeglasses-pdp-main__option-input:checked");
            if (checkedInput) {
                options.push(checkedInput.value);
            }
        });
        return options;
    }
    function formatMoney(cents) {
        return "$" + (cents / 100).toFixed(2).replace(/\.00$/, "");
    }
    function updateMainImage(imageUrl) {
        if (!mainImageEl || !imageUrl) return;
        if (mainImageEl.src === imageUrl) return;
        if (typeof gsap !== "undefined") {
            gsap.to(mainImageEl, {
                opacity: 0,
                duration: .2,
                onComplete: () => {
                    mainImageEl.src = imageUrl;
                    mainImageEl.onload = () => {
                        gsap.to(mainImageEl, {
                            opacity: 1,
                            duration: .3
                        });
                    };
                }
            });
        } else {
            mainImageEl.src = imageUrl;
        }
    }
    function updateThumbnailSelection(imageUrl) {
        if (!imageUrl) {
            console.log("[Eyeglasses PDP] No variant image URL provided");
            return;
        }
        const thumbnails = document.querySelectorAll(".eyeglasses-pdp-main__thumbnail");
        if (!thumbnails.length) {
            console.log("[Eyeglasses PDP] No thumbnails found");
            return;
        }
        console.log("[Eyeglasses PDP] Looking for thumbnail matching:", imageUrl);
        console.log("[Eyeglasses PDP] Available thumbnails:", thumbnails.length);
        let matchFound = false;
        thumbnails.forEach((thumbnail, index) => {
            const thumbUrl = thumbnail.getAttribute("data-image-url");
            console.log(`[Eyeglasses PDP] Thumbnail ${index + 1} URL:`, thumbUrl);
            if (thumbUrl === imageUrl) {
                thumbnails.forEach(t => t.classList.remove("active"));
                thumbnail.classList.add("active");
                matchFound = true;
                console.log("[Eyeglasses PDP] Exact match found at thumbnail", index + 1);
            }
        });
        if (!matchFound) {
            const imageFilename = imageUrl.split("/").pop().split("?")[0];
            console.log("[Eyeglasses PDP] Trying filename match:", imageFilename);
            thumbnails.forEach((thumbnail, index) => {
                const thumbUrl = thumbnail.getAttribute("data-image-url");
                const thumbFilename = thumbUrl ? thumbUrl.split("/").pop().split("?")[0] : "";
                if (thumbFilename && thumbFilename === imageFilename) {
                    thumbnails.forEach(t => t.classList.remove("active"));
                    thumbnail.classList.add("active");
                    matchFound = true;
                    console.log("[Eyeglasses PDP] Filename match found at thumbnail", index + 1);
                }
            });
        }
        if (!matchFound) {
            const coreFilename = imageUrl.split("/").pop().split("?")[0].replace(/_\d+x\d*|\d+x\d*/g, "");
            console.log("[Eyeglasses PDP] Trying partial filename match:", coreFilename);
            thumbnails.forEach((thumbnail, index) => {
                const thumbUrl = thumbnail.getAttribute("data-image-url");
                const thumbCoreFilename = thumbUrl ? thumbUrl.split("/").pop().split("?")[0].replace(/_\d+x\d*|\d+x\d*/g, "") : "";
                if (thumbCoreFilename && thumbCoreFilename === coreFilename) {
                    thumbnails.forEach(t => t.classList.remove("active"));
                    thumbnail.classList.add("active");
                    matchFound = true;
                    console.log("[Eyeglasses PDP] Partial filename match found at thumbnail", index + 1);
                }
            });
        }
        if (!matchFound) {
            console.log("[Eyeglasses PDP] No matching thumbnail found - keeping current selection");
        }
    }
    function updateVariantUI(variant) {
        if (!variant) return;
        if (variantIdInput) {
            variantIdInput.value = variant.id;
        }
        const installmentsBanner = document.querySelector("shopify-payment-terms");
        if (installmentsBanner && variant.id) {
            installmentsBanner.setAttribute("variant-id", variant.id);
        }
        if (priceElement) {
            priceElement.textContent = formatMoney(variant.price);
            const priceContainer = priceElement.closest(".eyeglasses-pdp-main__price");
            const compareAtElement = priceContainer?.querySelector(".eyeglasses-pdp-main__price-compare");
            const saleBadge = priceContainer?.querySelector(".eyeglasses-pdp-main__price-badge");
            if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
                if (compareAtElement) {
                    compareAtElement.textContent = formatMoney(variant.compareAtPrice);
                    compareAtElement.style.display = "";
                }
                if (saleBadge) saleBadge.style.display = "";
                priceElement.classList.add("eyeglasses-pdp-main__price-sale");
                priceElement.classList.remove("eyeglasses-pdp-main__price-regular");
            } else {
                if (compareAtElement) compareAtElement.style.display = "none";
                if (saleBadge) saleBadge.style.display = "none";
                priceElement.classList.remove("eyeglasses-pdp-main__price-sale");
                priceElement.classList.add("eyeglasses-pdp-main__price-regular");
            }
        }
        if (stockStatusElement) {
            if (variant.available) {
                stockStatusElement.innerHTML = '<span class="eyeglasses-pdp-main__stock-in"></span>';
                stockStatusElement.firstChild.textContent = ROOT.dataset.inStockLabel || "";
            } else {
                stockStatusElement.innerHTML = '<span class="eyeglasses-pdp-main__stock-out"></span>';
                stockStatusElement.firstChild.textContent = ROOT.dataset.outOfStockLabel || "";
            }
        }
        const cta = document.getElementById("buyCta");
        if (cta) {
            cta.setAttribute("aria-disabled", variant.available ? "false" : "true");
            cta.textContent = variant.available ? CTA_LABEL : SOLD_OUT_LABEL;
        }
        const framePriceEl = document.querySelector('[data-way-price="frame"]');
        const comboPriceEl = document.querySelector('[data-way-price="combo"]');
        if (framePriceEl) framePriceEl.textContent = formatMoney(variant.price);
        if (comboPriceEl) {
            comboPriceEl.textContent = FROM_TEMPLATE.replace("__P__", formatMoney(variant.price + CLIP_FROM_CENTS));
        }
        document.dispatchEvent(new CustomEvent("chemistrie:variant-changed"));
        if (variant.image) {
            updateMainImage(variant.image);
            updateThumbnailSelection(variant.image);
        } else if (variantData && variantData.featuredImage) {
            updateMainImage(variantData.featuredImage);
            updateThumbnailSelection(variantData.featuredImage);
        }
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", newUrl.toString());
        const customizeBtn = document.getElementById("customizeClipsBtn");
        if (customizeBtn) {
            const baseHref = customizeBtn.dataset.baseHref;
            if (baseHref) {
                const variantTitle = encodeURIComponent(variant.title);
                const newUrl = new URL(`${baseHref}&variant=${variant.id}&variantTitle=${variantTitle}`, window.location.origin);
                const currentUrl = new URL(customizeBtn.href, window.location.origin);
                if (currentUrl.searchParams.get("source") === "order-flow") {
                    newUrl.searchParams.set("source", "order-flow");
                    newUrl.searchParams.set("return", "true");
                }
                customizeBtn.href = newUrl.toString();
                console.log("[Eyeglasses PDP] Updated customize button URL with variant:", variant.id, variant.title);
            }
        }
        document.dispatchEvent(new CustomEvent("variant:changed", {
            detail: {
                variant: variant
            }
        }));
        console.log("[Eyeglasses PDP] Variant updated:", variant.title, "ID:", variant.id);
    }
    function initVariantFromURL() {
        if (!variantData) return;
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get("variant");
        if (variantId) {
            const variant = variantData.variants.find(v => v.id === parseInt(variantId));
            if (variant) {
                variant.options.forEach((optionValue, index) => {
                    const input = document.querySelector(`.eyeglasses-pdp-main__option-input[name="options[${variantData.options[index]}]"][value="${optionValue}"]`);
                    if (input) {
                        input.checked = true;
                    }
                });
                updateVariantUI(variant);
            }
        }
    }
    if (variantInputs.length && variantData) {
        variantInputs.forEach(input => {
            input.addEventListener("change", () => {
                const selectedOptions = getSelectedOptions();
                const variant = findVariantByOptions(selectedOptions);
                const optionGroup = input.closest(".eyeglasses-pdp-main__option");
                if (optionGroup) {
                    const colorLabel = optionGroup.querySelector(".eyeglasses-pdp-main__selected-color");
                    if (colorLabel) {
                        colorLabel.textContent = input.value;
                    }
                }
                if (variant) {
                    updateVariantUI(variant);
                } else {
                    console.warn("[Eyeglasses PDP] No matching variant found for options:", selectedOptions);
                }
            });
        });
        initVariantFromURL();
    }
    const customizeBtn = document.getElementById("customizeClipsBtn");
    const customizeBtnText = document.getElementById("customizeBtnText");
    if (customizeBtn && customizeBtnText) {
        const urlParams = new URLSearchParams(window.location.search);
        const source = urlParams.get("source");
        const variant = urlParams.get("variant");
        console.log("[Eyeglasses PDP] Current URL:", window.location.href);
        console.log("[Eyeglasses PDP] URL Parameters:", {
            source: source,
            variant: variant,
            allParams: Object.fromEntries(urlParams.entries())
        });
        if (source === "order-flow" && variant === "new-frame-lenses") {
            console.log("[Eyeglasses PDP] SUCCESS: Variant C detected - applying UI changes");
            customizeBtn.hidden = false;
            const ways = document.querySelector(".eyeglasses-pdp-main__ways");
            const buyCta = document.getElementById("buyCta");
            if (ways) ways.hidden = true;
            if (buyCta) buyCta.hidden = true;
            customizeBtn.classList.remove("eyeglasses-pdp-main__cta--secondary");
            customizeBtn.classList.add("eyeglasses-pdp-main__cta--primary");
            const currentHref = customizeBtn.getAttribute("href");
            const hrefUrl = new URL(currentHref, window.location.origin);
            hrefUrl.searchParams.set("source", "order-flow");
            hrefUrl.searchParams.set("return", "true");
            customizeBtn.setAttribute("href", hrefUrl.toString());
            console.log("[Eyeglasses PDP] Variant C UI changes applied:", {
                buttonClass: "primary",
                normalBuyPathHidden: true,
                href: customizeBtn.getAttribute("href"),
                sourceParam: "order-flow (replaced from eyeglasses-pdp)"
            });
        } else {
            console.log("[Eyeglasses PDP] INFO: Not from Variant C - keeping default UI");
        }
    } else {
        console.log("[Eyeglasses PDP] WARNING: Button elements not found:", {
            customizeBtn: !!customizeBtn,
            customizeBtnText: !!customizeBtnText
        });
    }
    const enlargeBtn = document.getElementById("enlargeImageBtn");
    const zoomModal = document.getElementById("zoomModal");
    const zoomImageA = document.getElementById("zoomImageA");
    const zoomImageB = document.getElementById("zoomImageB");
    const zoomOverlay = document.querySelector(".eyeglasses-pdp-main__zoom-overlay");
    const zoomCloseBtn = document.querySelector(".eyeglasses-pdp-main__zoom-close");
    const zoomPrevBtn = document.getElementById("zoomPrevBtn");
    const zoomNextBtn = document.getElementById("zoomNextBtn");
    if (enlargeBtn && zoomModal && zoomImageA && zoomImageB) {
        let zoomImageUrls = [];
        let currentZoomIndex = 0;
        let activeLayer = "A";
        const buildImageArray = () => {
            zoomImageUrls = [];
            const thumbs = document.querySelectorAll(".eyeglasses-pdp-main__thumbnail");
            if (thumbs.length > 0) {
                thumbs.forEach(thumb => {
                    const url = thumb.getAttribute("data-image-url");
                    if (url) zoomImageUrls.push(url);
                });
            } else {
                if (mainImage && mainImage.src) {
                    zoomImageUrls.push(mainImage.src);
                }
            }
            if (zoomImageUrls.length <= 1) {
                if (zoomPrevBtn) zoomPrevBtn.classList.add("hidden");
                if (zoomNextBtn) zoomNextBtn.classList.add("hidden");
            } else {
                if (zoomPrevBtn) zoomPrevBtn.classList.remove("hidden");
                if (zoomNextBtn) zoomNextBtn.classList.remove("hidden");
            }
        };
        const findCurrentImageIndex = () => {
            const currentSrc = mainImage.src;
            const index = zoomImageUrls.findIndex(url => {
                const urlFilename = url.split("/").pop().split("?")[0];
                const currentFilename = currentSrc.split("/").pop().split("?")[0];
                return urlFilename === currentFilename || url === currentSrc;
            });
            return index >= 0 ? index : 0;
        };
        let isNavigating = false;
        const navigateToImage = index => {
            if (index < 0 || index >= zoomImageUrls.length) return;
            if (isNavigating) return;
            isNavigating = true;
            currentZoomIndex = index;
            const newUrl = zoomImageUrls[index];
            const currentImg = activeLayer === "A" ? zoomImageA : zoomImageB;
            const nextImg = activeLayer === "A" ? zoomImageB : zoomImageA;
            nextImg.src = newUrl;
            const performCrossfade = () => {
                if (typeof gsap !== "undefined") {
                    gsap.set(nextImg, {
                        zIndex: 2
                    });
                    gsap.set(currentImg, {
                        zIndex: 1
                    });
                    gsap.to(nextImg, {
                        opacity: 1,
                        duration: .3,
                        ease: "power2.out",
                        onComplete: () => {
                            gsap.set(currentImg, {
                                opacity: 0,
                                zIndex: 1
                            });
                            gsap.set(nextImg, {
                                zIndex: 1
                            });
                            activeLayer = activeLayer === "A" ? "B" : "A";
                            if (activeLayer === "A") {
                                zoomImageA.classList.add("eyeglasses-pdp-main__zoom-image--active");
                                zoomImageB.classList.remove("eyeglasses-pdp-main__zoom-image--active");
                            } else {
                                zoomImageB.classList.add("eyeglasses-pdp-main__zoom-image--active");
                                zoomImageA.classList.remove("eyeglasses-pdp-main__zoom-image--active");
                            }
                            isNavigating = false;
                        }
                    });
                } else {
                    nextImg.style.opacity = "1";
                    currentImg.style.opacity = "0";
                    activeLayer = activeLayer === "A" ? "B" : "A";
                    isNavigating = false;
                }
                if (mainImage) {
                    mainImage.src = newUrl;
                }
                updateThumbnailSelection(newUrl);
            };
            if (nextImg.decode) {
                nextImg.decode().then(performCrossfade).catch(() => {
                    performCrossfade();
                });
            } else {
                nextImg.onload = performCrossfade;
                nextImg.onerror = () => {
                    isNavigating = false;
                    console.warn("Failed to load image:", newUrl);
                };
            }
        };
        const goToPrevImage = () => {
            let newIndex = currentZoomIndex - 1;
            if (newIndex < 0) newIndex = zoomImageUrls.length - 1;
            navigateToImage(newIndex);
        };
        const goToNextImage = () => {
            let newIndex = currentZoomIndex + 1;
            if (newIndex >= zoomImageUrls.length) newIndex = 0;
            navigateToImage(newIndex);
        };
        const openModal = () => {
            buildImageArray();
            currentZoomIndex = findCurrentImageIndex();
            const currentImageSrc = mainImage.src;
            activeLayer = "A";
            zoomImageA.src = currentImageSrc;
            zoomImageB.src = "";
            gsap.set(zoomImageA, {
                opacity: 1
            });
            gsap.set(zoomImageB, {
                opacity: 0
            });
            zoomImageA.classList.add("eyeglasses-pdp-main__zoom-image--active");
            zoomImageB.classList.remove("eyeglasses-pdp-main__zoom-image--active");
            gsap.set(zoomModal, {
                display: "flex"
            });
            gsap.fromTo(zoomModal, {
                opacity: 0
            }, {
                opacity: 1,
                duration: .3,
                ease: "power2.out"
            });
            document.body.style.overflow = "hidden";
        };
        const closeModal = () => {
            gsap.to(zoomModal, {
                opacity: 0,
                duration: .3,
                ease: "power2.in",
                onComplete: () => {
                    gsap.set(zoomModal, {
                        display: "none"
                    });
                    zoomImageA.src = "";
                    zoomImageB.src = "";
                }
            });
            document.body.style.overflow = "";
        };
        enlargeBtn.addEventListener("click", openModal);
        if (zoomPrevBtn) {
            zoomPrevBtn.addEventListener("click", e => {
                e.stopPropagation();
                goToPrevImage();
            });
        }
        if (zoomNextBtn) {
            zoomNextBtn.addEventListener("click", e => {
                e.stopPropagation();
                goToNextImage();
            });
        }
        if (zoomCloseBtn) {
            zoomCloseBtn.addEventListener("click", closeModal);
        }
        if (zoomOverlay) {
            zoomOverlay.addEventListener("click", closeModal);
        }
        document.addEventListener("keydown", e => {
            if (zoomModal.style.display !== "flex") return;
            switch (e.key) {
              case "Escape":
                closeModal();
                break;

              case "ArrowLeft":
                e.preventDefault();
                goToPrevImage();
                break;

              case "ArrowRight":
                e.preventDefault();
                goToNextImage();
                break;
            }
        });
    }
    const buyCta = document.getElementById("buyCta");
    const wayInputs = document.querySelectorAll(".eyeglasses-pdp-main__way-input");
    function syncBuyCta() {
        if (!buyCta) return;
        const variantInput = document.getElementById("productVariantId");
        const id = variantInput ? parseInt(variantInput.value, 10) : NaN;
        let url;
        try {
            url = new URL(buyCta.getAttribute("href"), window.location.origin);
        } catch (e) {
            return;
        }
        if (id) url.searchParams.set("variant", String(id));
        const data = document.getElementById("productVariantData");
        if (data && id) {
            try {
                const parsed = JSON.parse(data.textContent);
                const match = (parsed.variants || []).find(function(x) {
                    return x.id === id;
                });
                if (match && match.title) url.searchParams.set("variantTitle", match.title);
            } catch (e) {}
        }
        const chosen = document.querySelector(".eyeglasses-pdp-main__way-input:checked");
        if (chosen && chosen.value === "prescription-only") {
            url.searchParams.set("mode", "prescription-only");
        } else {
            url.searchParams.delete("mode");
        }
        buyCta.setAttribute("href", url.pathname + url.search);
    }
    wayInputs.forEach(function(input) {
        input.addEventListener("change", syncBuyCta);
    });
    document.addEventListener("chemistrie:variant-changed", syncBuyCta);
    syncBuyCta();
    const thumbScroller = document.querySelector(".eyeglasses-pdp-main__thumb-scroller");
    if (thumbScroller) {
        const row = thumbScroller.querySelector(".eyeglasses-pdp-main__thumbnails");
        const arrows = thumbScroller.querySelectorAll(".eyeglasses-pdp-main__thumb-arrow");
        const syncArrows = function() {
            const max = row.scrollWidth - row.clientWidth;
            arrows.forEach(function(btn) {
                const dir = Number(btn.dataset.thumbDir);
                btn.disabled = dir < 0 ? row.scrollLeft <= 2 : row.scrollLeft >= max - 2;
            });
        };
        arrows.forEach(function(btn) {
            btn.addEventListener("click", function() {
                row.scrollBy({
                    left: Number(btn.dataset.thumbDir) * (row.clientWidth * .8),
                    behavior: "smooth"
                });
            });
        });
        row.addEventListener("scroll", syncArrows, {
            passive: true
        });
        window.addEventListener("resize", syncArrows);
        syncArrows();
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eyeglasses-product-grid"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const sortSelect = document.getElementById("SortBy");
    if (sortSelect) {
        sortSelect.addEventListener("change", function() {
            const sortValue = this.value;
            const url = new URL(window.location.href);
            url.searchParams.set("sort_by", sortValue);
            window.location.href = url.toString();
        });
        const urlParams = new URLSearchParams(window.location.search);
        const currentSort = urlParams.get("sort_by");
        if (currentSort) {
            sortSelect.value = currentSort;
        }
    }
    const gridArea = document.querySelector(".eyeglasses-plp-grid-area");
    const sidebar = document.querySelector(".eyeglasses-filter-sidebar");
    if (gridArea && sidebar) {
        const stickyObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const gridRect = gridArea.getBoundingClientRect();
                const sidebarHeight = sidebar.offsetHeight;
                if (gridRect.bottom < sidebarHeight + 120) {
                    sidebar.classList.add("sidebar--unstuck");
                } else {
                    sidebar.classList.remove("sidebar--unstuck");
                }
            });
        }, {
            threshold: [ 0, .1, .5, .9, 1 ],
            rootMargin: "0px"
        });
        stickyObserver.observe(gridArea);
        let scrollTimeout;
        window.addEventListener("scroll", () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                const gridRect = gridArea.getBoundingClientRect();
                const sidebarHeight = sidebar.offsetHeight;
                if (gridRect.bottom < sidebarHeight + 120) {
                    sidebar.classList.add("sidebar--unstuck");
                } else {
                    sidebar.classList.remove("sidebar--unstuck");
                }
            }, 10);
        }, {
            passive: true
        });
    }
    const urlParams = new URLSearchParams(window.location.search);
    const orderFlow = urlParams.get("order_flow");
    const variant = urlParams.get("variant");
    console.log("[Eyeglasses Collection] Current URL:", window.location.href);
    console.log("[Eyeglasses Collection] URL Parameters:", {
        orderFlow: orderFlow,
        variant: variant,
        allParams: Object.fromEntries(urlParams.entries())
    });
    if (orderFlow === "true" && variant === "new-frame-lenses") {
        console.log("[Eyeglasses Collection] SUCCESS: Variant C detected - appending parameters to product links");
        const productLinks = document.querySelectorAll(".product-card__image-link, .product-card__title a");
        productLinks.forEach(link => {
            const url = new URL(link.href);
            url.searchParams.set("source", "order-flow");
            url.searchParams.set("variant", "new-frame-lenses");
            link.href = url.toString();
            console.log("[Eyeglasses Collection] Updated link:", link.href);
        });
    } else {
        console.log("[Eyeglasses Collection] INFO: Not from Variant C - keeping default product links");
    }
    (function initColorSwatches() {
        const productCards = document.querySelectorAll(".product-card");
        productCards.forEach(card => {
            const swatches = card.querySelectorAll(".product-card__color-swatch");
            const mainImage = card.querySelector(".product-card__image");
            const hoverImage = card.querySelector(".product-card__image-hover");
            const crossfadeImage = card.querySelector(".product-card__image-crossfade");
            const variantDataScript = card.querySelector(".product-card__variant-data");
            if (!swatches.length || !mainImage || !crossfadeImage) return;
            let variantData = null;
            if (variantDataScript) {
                try {
                    variantData = JSON.parse(variantDataScript.textContent);
                } catch (e) {
                    console.error("[PLP Swatches] Failed to parse variant data:", e);
                }
            }
            let isTransitioning = false;
            swatches.forEach(swatch => {
                swatch.addEventListener("click", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (isTransitioning) {
                        console.log("[PLP Swatches] Transition in progress, ignoring click");
                        return;
                    }
                    const colorName = this.dataset.color;
                    let imageUrl = null;
                    if (variantData && variantData.variants) {
                        const matchingVariant = variantData.variants.find(v => v.options && v.options.some(opt => opt === colorName));
                        if (matchingVariant && matchingVariant.image) {
                            imageUrl = matchingVariant.image;
                        } else {
                            imageUrl = variantData.featuredImage;
                        }
                    }
                    if (!imageUrl) {
                        console.log("[PLP Swatches] No image found for color:", colorName);
                        return;
                    }
                    if (mainImage.src === imageUrl || crossfadeImage.src === imageUrl) {
                        swatches.forEach(s => s.classList.remove("product-card__color-swatch--active"));
                        this.classList.add("product-card__color-swatch--active");
                        return;
                    }
                    isTransitioning = true;
                    swatches.forEach(s => s.classList.remove("product-card__color-swatch--active"));
                    this.classList.add("product-card__color-swatch--active");
                    card.classList.add("product-card--swatch-active");
                    crossfadeImage.src = imageUrl;
                    const performCrossfade = () => {
                        crossfadeImage.classList.add("is-visible");
                        setTimeout(() => {
                            mainImage.src = imageUrl;
                            mainImage.removeAttribute("srcset");
                            if (hoverImage) {
                                hoverImage.src = imageUrl;
                            }
                            requestAnimationFrame(() => {
                                crossfadeImage.classList.remove("is-visible");
                                setTimeout(() => {
                                    card.classList.remove("product-card--swatch-active");
                                    isTransitioning = false;
                                }, 50);
                            });
                        }, 320);
                    };
                    if (typeof crossfadeImage.decode === "function") {
                        crossfadeImage.decode().then(performCrossfade).catch(() => {
                            console.warn("[PLP Swatches] Image decode failed, using fallback");
                            performCrossfade();
                        });
                    } else {
                        const checkLoaded = () => {
                            if (crossfadeImage.complete && crossfadeImage.naturalWidth > 0) {
                                performCrossfade();
                            } else {
                                crossfadeImage.onload = performCrossfade;
                                crossfadeImage.onerror = () => {
                                    console.error("[PLP Swatches] Image load failed");
                                    isTransitioning = false;
                                    card.classList.remove("product-card--swatch-active");
                                };
                            }
                        };
                        checkLoaded();
                    }
                    console.log("[PLP Swatches] Crossfade initiated for color:", colorName);
                });
            });
        });
        console.log("[PLP Swatches] Initialized with crossfade for", productCards.length, "cards");
    })();
    window.updateProductImagesByColorFilter = function(selectedColorFamily) {
        if (!selectedColorFamily) {
            console.log("[Color Filter Sync] No color selected, skipping image update");
            return;
        }
        const normalizedColor = selectedColorFamily.toLowerCase().trim();
        console.log("[Color Filter Sync] Updating images for color family:", normalizedColor);
        const productCards = document.querySelectorAll(".product-card:not(.filter-hidden)");
        let updatedCount = 0;
        productCards.forEach(card => {
            const variantDataScript = card.querySelector(".product-card__variant-data");
            const mainImage = card.querySelector(".product-card__image");
            const crossfadeImage = card.querySelector(".product-card__image-crossfade");
            const swatches = card.querySelectorAll(".product-card__color-swatch");
            if (!variantDataScript || !mainImage) return;
            let variantData = null;
            try {
                variantData = JSON.parse(variantDataScript.textContent);
            } catch (e) {
                console.error("[Color Filter Sync] Failed to parse variant data:", e);
                return;
            }
            if (!variantData || !variantData.variants) return;
            const matchingVariant = variantData.variants.find(v => v.colorFamily && v.colorFamily.some(cf => cf === normalizedColor));
            if (!matchingVariant) {
                return;
            }
            const imageUrl = matchingVariant.image || variantData.featuredImage;
            if (!imageUrl) return;
            if (mainImage.src === imageUrl) {
                updateSwatchState();
                return;
            }
            function updateSwatchState() {
                if (!swatches.length) return;
                swatches.forEach(swatch => {
                    const swatchColor = swatch.dataset.color;
                    const isMatch = matchingVariant.options && matchingVariant.options.some(opt => opt === swatchColor);
                    if (isMatch) {
                        swatches.forEach(s => s.classList.remove("product-card__color-swatch--active"));
                        swatch.classList.add("product-card__color-swatch--active");
                    }
                });
            }
            if (crossfadeImage) {
                card.classList.add("product-card--swatch-active");
                crossfadeImage.src = imageUrl;
                const performCrossfade = () => {
                    crossfadeImage.classList.add("is-visible");
                    setTimeout(() => {
                        mainImage.src = imageUrl;
                        mainImage.removeAttribute("srcset");
                        const hoverImage = card.querySelector(".product-card__image-hover");
                        if (hoverImage) {
                            hoverImage.src = imageUrl;
                        }
                        requestAnimationFrame(() => {
                            crossfadeImage.classList.remove("is-visible");
                            setTimeout(() => {
                                card.classList.remove("product-card--swatch-active");
                            }, 50);
                        });
                    }, 320);
                };
                if (typeof crossfadeImage.decode === "function") {
                    crossfadeImage.decode().then(performCrossfade).catch(performCrossfade);
                } else {
                    if (crossfadeImage.complete) {
                        performCrossfade();
                    } else {
                        crossfadeImage.onload = performCrossfade;
                    }
                }
            } else {
                mainImage.src = imageUrl;
                mainImage.removeAttribute("srcset");
            }
            updateSwatchState();
            updatedCount++;
        });
        console.log("[Color Filter Sync] Updated", updatedCount, "product cards for color:", normalizedColor);
    };
    window.resetProductImagesToDefault = function() {
        console.log("[Color Filter Sync] Resetting images to default");
        const productCards = document.querySelectorAll(".product-card");
        productCards.forEach(card => {
            const variantDataScript = card.querySelector(".product-card__variant-data");
            const mainImage = card.querySelector(".product-card__image");
            const swatches = card.querySelectorAll(".product-card__color-swatch");
            if (!variantDataScript || !mainImage) return;
            let variantData = null;
            try {
                variantData = JSON.parse(variantDataScript.textContent);
            } catch (e) {
                return;
            }
            if (variantData && variantData.featuredImage) {
                mainImage.src = variantData.featuredImage;
                mainImage.removeAttribute("srcset");
            }
            if (swatches.length) {
                swatches.forEach(s => s.classList.remove("product-card__color-swatch--active"));
                swatches[0].classList.add("product-card__color-swatch--active");
            }
        });
    };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eyeglasses-products-carousel"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    function init() {
        const carousels = document.querySelectorAll(".eyeglasses-carousel");
        carousels.forEach(function(carousel) {
            const source = carousel.dataset.source;
            if (source === "recommendations") {
                loadRecommendations(carousel);
            }
            initCarouselNavigation(carousel);
            animateCardsEntrance(carousel);
        });
    }
    function loadRecommendations(carousel) {
        const recommendationsContainer = carousel.querySelector(".eyeglasses-carousel__recommendations");
        if (!recommendationsContainer) return;
        const url = recommendationsContainer.dataset.url;
        if (!url) return;
        var observer = new IntersectionObserver(function(entries, obs) {
            if (!entries[0].isIntersecting) return;
            obs.unobserve(recommendationsContainer);
            fetch(url).then(function(response) {
                return response.text();
            }).then(function(text) {
                var html = document.createElement("div");
                html.innerHTML = text;
                var newRecommendations = html.querySelector(".eyeglasses-carousel__recommendations");
                if (newRecommendations && newRecommendations.innerHTML.trim().length) {
                    recommendationsContainer.innerHTML = newRecommendations.innerHTML;
                    initCarouselNavigation(carousel);
                    animateCardsEntrance(carousel);
                }
            }).catch(function(error) {
                console.error("Error loading recommendations:", error);
                recommendationsContainer.innerHTML = '<p class="eyeglasses-carousel__empty">Unable to load recommendations</p>';
            });
        }, {
            rootMargin: "200px 0px"
        });
        observer.observe(recommendationsContainer);
    }
    function initCarouselNavigation(carousel) {
        var track = carousel.querySelector(".eyeglasses-carousel__track");
        var prevBtn = carousel.querySelector(".eyeglasses-carousel__arrow--prev");
        var nextBtn = carousel.querySelector(".eyeglasses-carousel__arrow--next");
        function getCards() {
            return carousel.querySelectorAll(".product-card.eyeglasses-product-card");
        }
        var cards = getCards();
        console.log("[Carousel Debug] Initial card count:", cards.length);
        console.log("[Carousel Debug] Track exists:", !!track);
        console.log("[Carousel Debug] Prev button:", !!prevBtn);
        console.log("[Carousel Debug] Next button:", !!nextBtn);
        if (!track) {
            console.error("[Carousel] Track element not found");
            return;
        }
        var currentPosition = 0;
        var cardsPerView = getCardsPerView();
        function getCardsPerView() {
            var width = window.innerWidth;
            if (width > 1200) return 4;
            if (width > 1024) return 3;
            if (width > 480) return 2;
            return 1;
        }
        function updateTrackPosition() {
            var currentCards = getCards();
            if (currentCards.length === 0) return;
            var cardWidth = currentCards[0].offsetWidth;
            var gap = 24;
            var offset = -(currentPosition * (cardWidth + gap));
            if (typeof gsap !== "undefined") {
                gsap.to(track, {
                    x: offset,
                    duration: .6,
                    ease: "power2.inOut"
                });
            } else {
                track.style.transform = "translateX(" + offset + "px)";
            }
        }
        function updateButtonStates() {
            var currentCards = getCards();
            var totalCards = currentCards.length;
            var maxPosition = Math.max(0, totalCards - cardsPerView);
            console.log("[Carousel Debug] Button state update - Cards:", totalCards, "PerView:", cardsPerView, "MaxPos:", maxPosition, "CurrentPos:", currentPosition);
            if (prevBtn) {
                prevBtn.disabled = currentPosition === 0;
            }
            if (nextBtn) {
                var shouldDisableNext = currentPosition >= maxPosition;
                nextBtn.disabled = shouldDisableNext;
                console.log("[Carousel Debug] Next button disabled:", shouldDisableNext);
            }
        }
        function slidePrev() {
            if (currentPosition > 0) {
                currentPosition--;
                updateTrackPosition();
                updateButtonStates();
            }
        }
        function slideNext() {
            var currentCards = getCards();
            var maxPosition = Math.max(0, currentCards.length - cardsPerView);
            console.log("[Carousel Debug] slideNext - MaxPos:", maxPosition, "CurrentPos:", currentPosition);
            if (currentPosition < maxPosition) {
                currentPosition++;
                updateTrackPosition();
                updateButtonStates();
            }
        }
        function handleResize() {
            var newCardsPerView = getCardsPerView();
            if (newCardsPerView !== cardsPerView) {
                cardsPerView = newCardsPerView;
                var currentCards = getCards();
                var maxPosition = Math.max(0, currentCards.length - cardsPerView);
                if (currentPosition > maxPosition) {
                    currentPosition = maxPosition;
                    updateTrackPosition();
                }
                updateButtonStates();
            }
        }
        if (prevBtn) {
            prevBtn.replaceWith(prevBtn.cloneNode(true));
            prevBtn = carousel.querySelector(".eyeglasses-carousel__arrow--prev");
            prevBtn.addEventListener("click", slidePrev);
        }
        if (nextBtn) {
            nextBtn.replaceWith(nextBtn.cloneNode(true));
            nextBtn = carousel.querySelector(".eyeglasses-carousel__arrow--next");
            nextBtn.addEventListener("click", slideNext);
        }
        window.addEventListener("resize", handleResize);
        requestAnimationFrame(function() {
            updateButtonStates();
        });
    }
    function animateCardsEntrance(carousel) {
        var cards = carousel.querySelectorAll(".product-card.eyeglasses-product-card");
        if (typeof gsap !== "undefined" && cards.length > 0) {
            gsap.fromTo(cards, {
                y: 20,
                opacity: 0
            }, {
                y: 0,
                opacity: 1,
                duration: .5,
                stagger: .1,
                ease: "power2.out",
                delay: .2
            });
        } else {
            cards.forEach(function(card) {
                card.style.opacity = "1";
                card.style.transform = "translateY(0)";
            });
        }
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
    window.EyeglassesCarousel = {
        init: init
    };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    (function() {
    function bindAccordion(root) {
        var questions = root.querySelectorAll(".faq-accordion__question");
        questions.forEach(function(question) {
            if (question.dataset.faqBound === "true") {
                return;
            }
            question.dataset.faqBound = "true";
            question.addEventListener("click", function() {
                var isExpanded = this.getAttribute("aria-expanded") === "true";
                var answer = document.getElementById(this.getAttribute("aria-controls"));
                var list = this.closest(".faq-accordion__list");
                if (list) {
                    list.querySelectorAll(".faq-accordion__question").forEach(function(other) {
                        if (other !== question) {
                            other.setAttribute("aria-expanded", "false");
                            var otherAnswer = document.getElementById(other.getAttribute("aria-controls"));
                            if (otherAnswer) {
                                otherAnswer.setAttribute("aria-hidden", "true");
                            }
                        }
                    });
                }
                this.setAttribute("aria-expanded", String(!isExpanded));
                if (answer) {
                    answer.setAttribute("aria-hidden", String(isExpanded));
                }
            });
        });
    }
    function bindAll() {
        document.querySelectorAll(".faq-accordion").forEach(bindAccordion);
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", bindAll);
    } else {
        bindAll();
    }
    document.addEventListener("shopify:section:load", function(event) {
        if (event.target && event.target.querySelector) {
            var root = event.target.querySelector(".faq-accordion");
            if (root) {
                bindAccordion(root);
            }
        }
    });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const searchInput = document.getElementById("faq-search");
    const topicChips = document.querySelectorAll(".faq__topic-chip");
    const categoryCards = document.querySelectorAll(".faq__category-card");
    const categorySections = document.querySelectorAll(".faq__category-section");
    let currentActiveCategory = "product-fit";
    console.log("FAQ Debug:", {
        searchInput: !!searchInput,
        categoryCards: categoryCards.length,
        categorySections: categorySections.length,
        topicChips: topicChips.length
    });
    function handleURLParameters() {
        const urlParams = new URLSearchParams(window.location.search);
        const searchQuery = urlParams.get("search");
        const categoryParam = urlParams.get("category");
        if (searchQuery && searchInput) {
            searchInput.value = decodeURIComponent(searchQuery);
            searchInput.dispatchEvent(new Event("input"));
            setTimeout(() => {
                const faqContent = document.querySelector(".faq__content");
                if (faqContent) {
                    scrollToElement(faqContent);
                }
            }, 300);
            console.log("FAQ: Applied search from URL:", searchQuery);
        }
        if (categoryParam && !searchQuery) {
            const targetCard = document.querySelector(`[data-category="${categoryParam}"]`);
            if (targetCard) {
                targetCard.click();
                console.log("FAQ: Activated category from URL:", categoryParam);
            }
        }
    }
    function scrollToElement(element) {
        const rect = element.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let headerOffset = 0;
        const stickyHeader = document.querySelector(".chemistrie-header.is-sticky");
        const announcementBar = document.querySelector(".announcement-bar");
        const regularHeader = document.querySelector(".chemistrie-header");
        if (stickyHeader || regularHeader) {
            headerOffset = announcementBar ? 120 : 84;
        }
        const targetPosition = rect.top + scrollTop - headerOffset - 20;
        window.scrollTo({
            top: Math.max(0, targetPosition),
            behavior: "smooth"
        });
    }
    if (searchInput) {
        searchInput.addEventListener("input", function() {
            const searchTerm = this.value.toLowerCase().trim();
            if (searchTerm === "") {
                restoreActiveCategory();
                return;
            }
            const searchWords = searchTerm.split(/\s+/).filter(word => word.length > 0);
            categoryCards.forEach(c => c.classList.remove("faq__category-card--active"));
            let hasResults = false;
            categorySections.forEach(section => {
                const questions = section.querySelectorAll(".faq__item");
                let sectionHasResults = false;
                questions.forEach(question => {
                    const questionText = question.querySelector(".faq__question-text").textContent.toLowerCase();
                    const answerText = question.querySelector(".faq__answer-content").textContent.toLowerCase();
                    const combinedText = questionText + " " + answerText;
                    const hasMatch = searchWords.some(word => combinedText.includes(word));
                    if (hasMatch) {
                        question.style.display = "block";
                        sectionHasResults = true;
                        hasResults = true;
                    } else {
                        question.style.display = "none";
                    }
                });
                if (sectionHasResults) {
                    section.classList.add("faq__category-section--active");
                    section.style.display = "block";
                } else {
                    section.classList.remove("faq__category-section--active");
                    section.style.display = "none";
                }
            });
            console.log("Search results:", {
                searchWords: searchWords,
                hasResults: hasResults
            });
        });
    }
    function restoreActiveCategory() {
        categorySections.forEach(s => {
            s.classList.remove("faq__category-section--active");
            s.style.display = "none";
            const questions = s.querySelectorAll(".faq__item");
            questions.forEach(q => q.style.display = "block");
        });
        categoryCards.forEach(c => c.classList.remove("faq__category-card--active"));
        const activeCard = document.querySelector(`[data-category="${currentActiveCategory}"]`);
        const activeSection = document.querySelector(`.faq__category-section[data-category="${currentActiveCategory}"]`);
        if (activeCard && activeSection) {
            activeCard.classList.add("faq__category-card--active");
            activeSection.classList.add("faq__category-section--active");
            activeSection.style.display = "block";
        }
        console.log("Restored active category:", currentActiveCategory);
    }
    topicChips.forEach(chip => {
        chip.addEventListener("click", function() {
            if (searchInput) {
                searchInput.value = this.dataset.topic;
                searchInput.dispatchEvent(new Event("input"));
            }
        });
    });
    categoryCards.forEach(card => {
        card.addEventListener("click", function() {
            const category = this.getAttribute("data-category");
            console.log("Category card clicked:", category);
            currentActiveCategory = category;
            if (searchInput) {
                searchInput.value = "";
            }
            categoryCards.forEach(c => c.classList.remove("faq__category-card--active"));
            categorySections.forEach(s => {
                s.classList.remove("faq__category-section--active");
                s.style.display = "none";
            });
            this.classList.add("faq__category-card--active");
            const targetSection = document.querySelector(`.faq__category-section[data-category="${category}"]`);
            console.log("Target section found:", !!targetSection);
            if (targetSection) {
                targetSection.classList.add("faq__category-section--active");
                targetSection.style.display = "block";
                const questions = targetSection.querySelectorAll(".faq__item");
                questions.forEach(q => q.style.display = "block");
                console.log("Questions in section:", questions.length);
            } else {
                console.error("Could not find section for category:", category);
            }
            const faqContent = document.querySelector(".faq__content");
            if (faqContent) {
                const rect = faqContent.getBoundingClientRect();
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                let headerOffset = 0;
                const stickyHeader = document.querySelector(".chemistrie-header.is-sticky");
                const announcementBar = document.querySelector(".announcement-bar");
                const regularHeader = document.querySelector(".chemistrie-header");
                if (stickyHeader || regularHeader) {
                    headerOffset = announcementBar ? 120 : 84;
                }
                const targetPosition = rect.top + scrollTop - headerOffset - 20;
                console.log("Scroll calculation:", {
                    headerOffset: headerOffset,
                    hasAnnouncement: !!announcementBar,
                    isSticky: !!stickyHeader,
                    targetPosition: targetPosition
                });
                window.scrollTo({
                    top: Math.max(0, targetPosition),
                    behavior: "smooth"
                });
            }
        });
    });
    const questions = document.querySelectorAll(".faq__question");
    questions.forEach(question => {
        question.addEventListener("click", function() {
            const isExpanded = this.getAttribute("aria-expanded") === "true";
            const answer = this.nextElementSibling;
            this.setAttribute("aria-expanded", !isExpanded);
            answer.setAttribute("aria-hidden", isExpanded);
            const currentSection = this.closest(".faq__category-section");
            if (currentSection) {
                const otherQuestions = currentSection.querySelectorAll(".faq__question");
                otherQuestions.forEach(otherQuestion => {
                    if (otherQuestion !== this) {
                        otherQuestion.setAttribute("aria-expanded", "false");
                        otherQuestion.nextElementSibling.setAttribute("aria-hidden", "true");
                    }
                });
            }
        });
    });
    categoryCards.forEach((card, index) => {
        card.addEventListener("keydown", function(e) {
            if (e.key === "ArrowLeft" && index > 0) {
                categoryCards[index - 1].focus();
                categoryCards[index - 1].click();
            } else if (e.key === "ArrowRight" && index < categoryCards.length - 1) {
                categoryCards[index + 1].focus();
                categoryCards[index + 1].click();
            }
        });
    });
    function initializeFAQ() {
        console.log("Initializing FAQ with default category:", currentActiveCategory);
        const firstCard = document.querySelector('[data-category="product-fit"]');
        const firstSection = document.querySelector('.faq__category-section[data-category="product-fit"]');
        if (firstCard && firstSection) {
            categoryCards.forEach(c => c.classList.remove("faq__category-card--active"));
            firstCard.classList.add("faq__category-card--active");
            categorySections.forEach(s => {
                s.classList.remove("faq__category-section--active");
                s.style.display = "none";
            });
            firstSection.classList.add("faq__category-section--active");
            firstSection.style.display = "block";
            const questions = firstSection.querySelectorAll(".faq__item");
            questions.forEach(q => q.style.display = "block");
            console.log("FAQ initialized successfully", {
                firstCard: !!firstCard,
                firstSection: !!firstSection,
                questionsCount: questions.length
            });
        } else {
            console.error("Could not initialize FAQ - missing elements", {
                firstCard: !!firstCard,
                firstSection: !!firstSection
            });
        }
    }
    setTimeout(() => {
        initializeFAQ();
        handleURLParameters();
    }, 100);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const footerLinks = document.querySelectorAll('.footer__link[href^="#"]');
    footerLinks.forEach(link => {
        link.addEventListener("click", function(e) {
            e.preventDefault();
            const targetId = this.getAttribute("href").substring(1);
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }
        });
    });
});

(function() {
    var lists = document.querySelectorAll(".footer__disclosure");
    if (!lists.length) return;
    var mq = window.matchMedia("(max-width: 768px)");
    function apply() {
        var collapse = mq.matches;
        lists.forEach(function(d) {
            if (d.dataset.userToggled === "true") return;
            d.open = !collapse;
        });
    }
    lists.forEach(function(d) {
        d.addEventListener("toggle", function() {
            if (d.dataset.applying !== "true") d.dataset.userToggled = "true";
        });
    });
    apply();
    if (mq.addEventListener) mq.addEventListener("change", apply); else if (mq.addListener) mq.addListener(apply);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-pdp-main"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    const thumbnails = document.querySelectorAll(".gift-card-pdp__thumbnail");
    const mainImage = document.getElementById("giftCardMainImage");
    const variantInputs = document.querySelectorAll(".gift-card-pdp__option-input");
    const variantDataElement = document.getElementById("giftCardVariantData");
    const variantIdInput = document.getElementById("giftCardVariantId");
    const priceElement = document.getElementById("giftCardPriceValue");
    const addToCartBtn = document.getElementById("giftCardAddToCartBtn");
    const productForm = document.getElementById("giftCardForm");
    const sendAsGiftCheckbox = document.getElementById("GiftSendAsGift");
    const recipientWrap = document.getElementById("giftRecipientWrap");
    const recipientEmailInput = document.getElementById("GiftRecipientEmail");
    const recipientEmailError = document.getElementById("giftRecipientEmailError");
    const messageTextarea = document.getElementById("GiftMessage");
    const messageCounter = document.getElementById("giftMessageCount");
    let variantData = null;
    if (variantDataElement) {
        try {
            variantData = JSON.parse(variantDataElement.textContent);
        } catch (e) {
            console.error("[Gift Card PDP] Failed to parse variant data:", e);
        }
    }
    if (thumbnails.length && mainImage) {
        thumbnails.forEach(thumbnail => {
            thumbnail.addEventListener("click", function() {
                thumbnails.forEach(t => t.classList.remove("active"));
                this.classList.add("active");
                const newImageUrl = this.getAttribute("data-image-url");
                if (newImageUrl) {
                    fadeSwapImage(mainImage, newImageUrl);
                }
            });
        });
    }
    function fadeSwapImage(imgEl, newUrl) {
        if (!imgEl || !newUrl || imgEl.src === newUrl) return;
        if (typeof gsap !== "undefined") {
            gsap.to(imgEl, {
                opacity: 0,
                duration: .2,
                onComplete: () => {
                    imgEl.src = newUrl;
                    gsap.to(imgEl, {
                        opacity: 1,
                        duration: .3
                    });
                }
            });
        } else {
            imgEl.src = newUrl;
        }
    }
    function getSelectedOptions() {
        const options = [];
        document.querySelectorAll(".gift-card-pdp__option").forEach(group => {
            const checked = group.querySelector(".gift-card-pdp__option-input:checked");
            if (checked) options.push(checked.value);
        });
        return options;
    }
    function findVariantByOptions(selected) {
        if (!variantData || !variantData.variants) return null;
        return variantData.variants.find(v => selected.every((opt, i) => v.options[i] === opt));
    }
    function formatMoney(cents) {
        return "$" + (cents / 100).toFixed(2).replace(/\.00$/, "");
    }
    function updateVariantUI(variant) {
        if (!variant) return;
        if (variantIdInput) variantIdInput.value = variant.id;
        if (priceElement) {
            priceElement.textContent = formatMoney(variant.price);
            const priceContainer = priceElement.closest(".gift-card-pdp__price");
            const compareEl = priceContainer?.querySelector(".gift-card-pdp__price-compare");
            const saleBadge = priceContainer?.querySelector(".gift-card-pdp__price-badge");
            if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
                if (compareEl) {
                    compareEl.textContent = formatMoney(variant.compareAtPrice);
                    compareEl.style.display = "";
                }
                if (saleBadge) saleBadge.style.display = "";
                priceElement.classList.add("gift-card-pdp__price-sale");
                priceElement.classList.remove("gift-card-pdp__price-regular");
            } else {
                if (compareEl) compareEl.style.display = "none";
                if (saleBadge) saleBadge.style.display = "none";
                priceElement.classList.remove("gift-card-pdp__price-sale");
                priceElement.classList.add("gift-card-pdp__price-regular");
            }
        }
        if (variant.image) {
            fadeSwapImage(mainImage, variant.image);
        }
        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url.toString());
        document.dispatchEvent(new CustomEvent("variant:changed", {
            detail: {
                variant: variant
            }
        }));
    }
    function initVariantFromURL() {
        if (!variantData) return;
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get("variant");
        if (!variantId) return;
        const variant = variantData.variants.find(v => v.id === parseInt(variantId, 10));
        if (!variant) return;
        variant.options.forEach((value, i) => {
            const input = document.querySelector(`.gift-card-pdp__option-input[name="options[${variantData.options[i]}]"][value="${value}"]`);
            if (input) input.checked = true;
        });
        updateVariantUI(variant);
    }
    if (variantInputs.length && variantData) {
        variantInputs.forEach(input => {
            input.addEventListener("change", () => {
                const variant = findVariantByOptions(getSelectedOptions());
                if (variant) updateVariantUI(variant);
            });
        });
        initVariantFromURL();
    }
    if (messageTextarea && messageCounter) {
        const updateCount = () => {
            messageCounter.textContent = messageTextarea.value.length;
        };
        messageTextarea.addEventListener("input", updateCount);
        updateCount();
    }
    function setGiftToggle(expanded) {
        if (!recipientWrap) return;
        recipientWrap.classList.toggle("is-expanded", expanded);
        recipientWrap.setAttribute("aria-hidden", String(!expanded));
        sendAsGiftCheckbox?.setAttribute("aria-expanded", String(expanded));
        recipientWrap.querySelectorAll("input, textarea").forEach(el => {
            el.disabled = !expanded;
        });
        if (!expanded && recipientEmailInput) {
            recipientEmailInput.classList.remove("is-invalid");
            if (recipientEmailError) {
                recipientEmailError.textContent = "";
                recipientEmailError.classList.remove("is-visible");
            }
        }
    }
    if (sendAsGiftCheckbox) {
        sendAsGiftCheckbox.addEventListener("change", () => setGiftToggle(sendAsGiftCheckbox.checked));
        setGiftToggle(sendAsGiftCheckbox.checked);
    }
    const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    function validateRecipientEmail() {
        if (!recipientEmailInput) return true;
        if (sendAsGiftCheckbox && !sendAsGiftCheckbox.checked) return true;
        const sendingAsGift = !!(sendAsGiftCheckbox && sendAsGiftCheckbox.checked);
        const required = sendingAsGift || recipientEmailInput.dataset.required === "true";
        const value = recipientEmailInput.value.trim();
        let errorKey = "";
        if (required && !value) {
            errorKey = "required";
        } else if (value && !EMAIL_REGEX.test(value)) {
            errorKey = "invalid";
        }
        if (errorKey) {
            recipientEmailInput.classList.add("is-invalid");
            if (recipientEmailError) {
                recipientEmailError.textContent = errorKey === "required" ? window.giftCardStrings?.emailRequired || "Recipient email is required." : window.giftCardStrings?.emailInvalid || "Please enter a valid email address.";
                recipientEmailError.classList.add("is-visible");
            }
            return false;
        }
        recipientEmailInput.classList.remove("is-invalid");
        if (recipientEmailError) {
            recipientEmailError.textContent = "";
            recipientEmailError.classList.remove("is-visible");
        }
        return true;
    }
    if (recipientEmailInput) {
        recipientEmailInput.addEventListener("blur", validateRecipientEmail);
        recipientEmailInput.addEventListener("input", () => {
            if (recipientEmailInput.classList.contains("is-invalid")) validateRecipientEmail();
        });
    }
    if (productForm) {
        productForm.addEventListener("submit", async e => {
            e.preventDefault();
            if (!validateRecipientEmail()) {
                if (recipientEmailInput) {
                    recipientEmailInput.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    });
                    setTimeout(() => recipientEmailInput.focus({
                        preventScroll: true
                    }), 350);
                }
                return;
            }
            const formData = new FormData(productForm);
            const submitButton = addToCartBtn;
            const originalText = submitButton?.textContent;
            const properties = {};
            [ "Recipient name", "Recipient email", "Message", "Send on" ].forEach(key => {
                const val = formData.get(`properties[${key}]`);
                if (val && val.toString().trim() !== "") {
                    properties[key] = val.toString().trim();
                }
            });
            if (sendAsGiftCheckbox && sendAsGiftCheckbox.checked) {
                properties["__shopify_send_gift_card_to_recipient"] = "on";
            }
            const payload = {
                id: formData.get("id"),
                quantity: 1,
                sections: "cart-drawer-items,cart-header-dropdown"
            };
            if (Object.keys(properties).length > 0) payload.properties = properties;
            if (submitButton) {
                submitButton.disabled = true;
                submitButton.textContent = window.giftCardStrings?.adding || "Adding...";
            }
            try {
                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    },
                    body: JSON.stringify(payload)
                });
                if (!response.ok) {
                    const errBody = await response.json().catch(() => ({}));
                    throw new Error(errBody.description || "Failed to add gift card to cart");
                }
                const data = await response.json();
                if (window.cartDrawer && data.sections) {
                    window.cartDrawer.updateCartSections(data.sections);
                }
                document.dispatchEvent(new CustomEvent("cart:item:added", {
                    detail: {
                        item: data.items ? data.items[0] : data,
                        sections: data.sections
                    }
                }));
                if (submitButton) {
                    submitButton.textContent = originalText;
                    submitButton.disabled = false;
                }
            } catch (error) {
                console.error("[Gift Card PDP] Error adding to cart:", error);
                alert(error.message || "Sorry, there was an error adding the gift card to your cart. Please try again.");
                if (submitButton) {
                    submitButton.textContent = originalText;
                    submitButton.disabled = false;
                }
            }
        });
    }
    const enlargeBtn = document.getElementById("giftCardEnlargeBtn");
    const zoomModal = document.getElementById("giftCardZoomModal");
    const zoomImage = document.getElementById("giftCardZoomImage");
    const zoomOverlay = document.getElementById("giftCardZoomOverlay");
    const zoomCloseBtn = document.getElementById("giftCardZoomCloseBtn");
    if (enlargeBtn && zoomModal && zoomImage && mainImage) {
        const openModal = () => {
            zoomImage.src = mainImage.src;
            if (typeof gsap !== "undefined") {
                gsap.set(zoomModal, {
                    display: "flex"
                });
                gsap.fromTo(zoomModal, {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: .3,
                    ease: "power2.out"
                });
            } else {
                zoomModal.style.display = "flex";
                zoomModal.style.opacity = "1";
            }
            document.body.style.overflow = "hidden";
        };
        const closeModal = () => {
            if (typeof gsap !== "undefined") {
                gsap.to(zoomModal, {
                    opacity: 0,
                    duration: .3,
                    ease: "power2.in",
                    onComplete: () => {
                        gsap.set(zoomModal, {
                            display: "none"
                        });
                        zoomImage.src = "";
                    }
                });
            } else {
                zoomModal.style.display = "none";
                zoomImage.src = "";
            }
            document.body.style.overflow = "";
        };
        enlargeBtn.addEventListener("click", openModal);
        zoomCloseBtn?.addEventListener("click", closeModal);
        zoomOverlay?.addEventListener("click", closeModal);
        document.addEventListener("keydown", e => {
            if (e.key === "Escape" && zoomModal.style.display === "flex") closeModal();
        });
    }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-chemistrie"] && !Shopify.designMode) return;
  try {
    function closeAllHeaderElements() {
    const searchField = document.querySelector("[data-search-field]");
    if (searchField) searchField.classList.remove("is-active");
    const header = document.querySelector(".chemistrie-header");
    if (header) header.classList.remove("search-active");
    const promotionsDialog = document.querySelector("[data-promotions-dialog]");
    if (promotionsDialog && promotionsDialog.classList.contains("is-active")) {
        promotionsDialog.classList.remove("is-active");
        document.body.style.overflow = "";
    }
    const accountDropdown = document.querySelector("[data-account-dropdown]");
    if (accountDropdown) accountDropdown.classList.remove("is-active");
    const cartDropdown = document.querySelector("[data-cart-dropdown]");
    if (cartDropdown) cartDropdown.classList.remove("is-active");
    const hamburgerMenu = document.querySelector("[data-dropdown-menu]");
    if (hamburgerMenu) hamburgerMenu.classList.remove("is-active");
    const mobileClipsOverlay = document.querySelector("[data-mobile-clips-overlay]");
    if (mobileClipsOverlay) {
        mobileClipsOverlay.classList.remove("is-active");
    }
    const mobileExtraOverlay = document.querySelector("[data-mobile-extra-overlay]");
    if (mobileExtraOverlay) {
        mobileExtraOverlay.classList.remove("is-active");
    }
    const navDropdowns = document.querySelectorAll(".chemistrie-header__nav-item--has-dropdown");
    navDropdowns.forEach(item => item.classList.remove("is-active"));
}

document.addEventListener("DOMContentLoaded", function() {
    const header = document.querySelector(".chemistrie-header");
    if (header) {
        header.classList.add("is-sticky");
        document.body.classList.add("header-is-sticky");
    }
    const announcementBar = document.querySelector(".announcement-bar");
    function updateHeaderStackHeight() {
        const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
        const headerHeight = header ? header.offsetHeight : 0;
        document.body.style.setProperty("--chemistrie-header-stack-height", announcementHeight + headerHeight + "px");
    }
    updateHeaderStackHeight();
    window.addEventListener("resize", updateHeaderStackHeight);
    if (typeof ResizeObserver !== "undefined") {
        const ro = new ResizeObserver(updateHeaderStackHeight);
        if (header) ro.observe(header);
        if (announcementBar) ro.observe(announcementBar);
    }
});

document.addEventListener("DOMContentLoaded", function() {
    const header = document.querySelector(".chemistrie-header");
    const searchToggle = document.querySelector('[data-action="search-toggle"]');
    const searchField = document.querySelector("[data-search-field]");
    const searchInput = document.querySelector(".chemistrie-header__search-input");
    const searchSlidedown = document.querySelector("[data-search-slidedown]");
    const searchSlidedownInput = document.querySelector("[data-search-slidedown-input]");
    const searchSlidedownClose = document.querySelector("[data-search-slidedown-close]");
    function isMobile() {
        return window.innerWidth <= 768;
    }
    function openSearch() {
        if (isMobile()) {
            if (header) header.classList.add("search-active");
            setTimeout(() => {
                if (searchSlidedownInput) searchSlidedownInput.focus();
            }, 300);
        } else {
            searchField.classList.add("is-active");
            setTimeout(() => {
                searchInput.focus();
            }, 100);
        }
    }
    function closeSearch() {
        searchField.classList.remove("is-active");
        if (header) header.classList.remove("search-active");
        if (searchInput) searchInput.blur();
        if (searchSlidedownInput) searchSlidedownInput.blur();
    }
    if (searchToggle) {
        searchToggle.addEventListener("click", function(e) {
            e.stopPropagation();
            const wasActive = isMobile() ? header.classList.contains("search-active") : searchField.classList.contains("is-active");
            closeAllHeaderElements();
            if (!wasActive) {
                openSearch();
            }
        });
        if (searchSlidedownClose) {
            searchSlidedownClose.addEventListener("click", function(e) {
                e.preventDefault();
                e.stopPropagation();
                closeSearch();
            });
        }
        document.addEventListener("click", function(e) {
            const isInsideDesktopSearch = searchField && searchField.contains(e.target);
            const isInsideMobileSearch = searchSlidedown && searchSlidedown.contains(e.target);
            const isSearchToggle = searchToggle.contains(e.target);
            if (!isInsideDesktopSearch && !isInsideMobileSearch && !isSearchToggle) {
                closeSearch();
            }
        });
        document.addEventListener("keydown", function(e) {
            if (e.key === "Escape") {
                const isSearchActive = isMobile() ? header.classList.contains("search-active") : searchField.classList.contains("is-active");
                if (isSearchActive) {
                    closeSearch();
                }
            }
        });
        window.addEventListener("resize", function() {
            if (!isMobile() && header && header.classList.contains("search-active")) {
                header.classList.remove("search-active");
            }
        });
    }
});

document.addEventListener("DOMContentLoaded", function() {
    const promotionsToggle = document.querySelector('[data-action="promotions-toggle"]');
    const promotionsDialog = document.querySelector("[data-promotions-dialog]");
    const promotionsOverlay = document.querySelector("[data-promotions-overlay]");
    const promotionsClose = document.querySelector("[data-promotions-close]");
    const copyCodeBtn = document.querySelector("[data-copy-code]");
    const emailForm = document.querySelector("[data-email-form]");
    if (promotionsToggle && promotionsDialog) {
        promotionsToggle.addEventListener("click", function(e) {
            e.stopPropagation();
            const wasActive = promotionsDialog.classList.contains("is-active");
            closeAllHeaderElements();
            if (!wasActive) {
                promotionsDialog.classList.add("is-active");
                document.body.style.overflow = "hidden";
            }
        });
        function closeDialog() {
            promotionsDialog.classList.remove("is-active");
            document.body.style.overflow = "";
        }
        if (promotionsOverlay) {
            promotionsOverlay.addEventListener("click", closeDialog);
        }
        if (promotionsClose) {
            promotionsClose.addEventListener("click", closeDialog);
        }
        document.addEventListener("keydown", function(e) {
            if (e.key === "Escape" && promotionsDialog.classList.contains("is-active")) {
                closeDialog();
            }
        });
        if (copyCodeBtn) {
            copyCodeBtn.addEventListener("click", function() {
                const code = this.getAttribute("data-copy-code");
                navigator.clipboard.writeText(code).then(() => {
                    this.textContent = "Copied!";
                    setTimeout(() => {
                        this.textContent = "Copy";
                    }, 2e3);
                });
            });
        }
        if (emailForm) {
            emailForm.addEventListener("submit", function(e) {
                e.preventDefault();
                const email = this.querySelector('input[type="email"]').value;
                const submitBtn = this.querySelector('button[type="submit"]');
                submitBtn.textContent = "Subscribed!";
                submitBtn.disabled = true;
                submitBtn.style.background = "var(--action)";
                setTimeout(() => {
                    this.querySelector('input[type="email"]').value = "";
                    submitBtn.textContent = "Subscribe";
                    submitBtn.disabled = false;
                    submitBtn.style.background = "";
                    closeDialog();
                }, 2e3);
            });
        }
    }
});

document.addEventListener("DOMContentLoaded", function() {
    const accountToggle = document.querySelector('[data-action="account-toggle"]');
    const accountDropdown = document.querySelector("[data-account-dropdown]");
    if (accountToggle && accountDropdown) {
        accountToggle.addEventListener("click", function(e) {
            e.stopPropagation();
            const wasActive = accountDropdown.classList.contains("is-active");
            closeAllHeaderElements();
            if (!wasActive) {
                accountDropdown.classList.add("is-active");
            }
        });
    }
    document.addEventListener("click", function(e) {
        if (accountDropdown && !accountDropdown.contains(e.target) && !accountToggle.contains(e.target)) {
            accountDropdown.classList.remove("is-active");
        }
    });
    const accountLinks = document.querySelectorAll(".chemistrie-header__account-link");
    accountLinks.forEach(link => {
        link.addEventListener("click", function() {
            if (accountDropdown) {
                accountDropdown.classList.remove("is-active");
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function() {
    const cartToggle = document.querySelector('[data-action="cart-toggle"]');
    const cartDropdown = document.querySelector("[data-cart-dropdown]");
    if (cartToggle && cartDropdown) {
        cartToggle.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (window.cartDrawer) {
                window.cartDrawer.openDrawer();
            }
        });
    }
    document.addEventListener("click", function(e) {
        if (cartDropdown && !cartDropdown.contains(e.target) && !cartToggle.contains(e.target)) {
            cartDropdown.classList.remove("is-active");
        }
    });
    const cartLinks = document.querySelectorAll(".chemistrie-header__cart-view, .chemistrie-header__cart-checkout");
    cartLinks.forEach(link => {
        link.addEventListener("click", function() {
            if (cartDropdown) {
                cartDropdown.classList.remove("is-active");
            }
        });
    });
    document.addEventListener("cart:item:added", function(e) {
        console.log("Cart item added event received:", e.detail);
        closeAllHeaderElements();
        if (window.cartDrawer) {
            window.cartDrawer.openDrawer();
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {
    const menuToggle = document.querySelector('[data-action="menu-toggle"]');
    const dropdownMenu = document.querySelector("[data-dropdown-menu]");
    const mobileClipsOverlay = document.querySelector("[data-mobile-clips-overlay]");
    const mobileExtraOverlay = document.querySelector("[data-mobile-extra-overlay]");
    if (menuToggle && dropdownMenu) {
        menuToggle.addEventListener("click", function(e) {
            e.stopPropagation();
            if (mobileClipsOverlay && mobileClipsOverlay.classList.contains("is-active") || mobileExtraOverlay && mobileExtraOverlay.classList.contains("is-active")) {
                if (mobileClipsOverlay) mobileClipsOverlay.classList.remove("is-active");
                if (mobileExtraOverlay) mobileExtraOverlay.classList.remove("is-active");
                dropdownMenu.classList.add("is-active");
                return;
            }
            const wasActive = dropdownMenu.classList.contains("is-active");
            closeAllHeaderElements();
            if (!wasActive) {
                dropdownMenu.classList.add("is-active");
            }
        });
    }
    const mobileClipsBtn = document.querySelector('[data-action="mobile-clips-menu"]');
    if (mobileClipsBtn && mobileClipsOverlay && dropdownMenu) {
        mobileClipsBtn.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            dropdownMenu.classList.remove("is-active");
            mobileClipsOverlay.classList.add("is-active");
        });
    }
    const mobileExtraBtn = document.querySelector('[data-action="mobile-extra-menu"]');
    if (mobileExtraBtn && mobileExtraOverlay && dropdownMenu) {
        mobileExtraBtn.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            dropdownMenu.classList.remove("is-active");
            mobileExtraOverlay.classList.add("is-active");
        });
    }
    document.addEventListener("click", function(e) {
        if (dropdownMenu && !dropdownMenu.contains(e.target) && !menuToggle.contains(e.target)) {
            dropdownMenu.classList.remove("is-active");
        }
        if (mobileClipsOverlay && mobileClipsOverlay.classList.contains("is-active") && !mobileClipsOverlay.contains(e.target) && !menuToggle.contains(e.target)) {
            mobileClipsOverlay.classList.remove("is-active");
        }
        if (mobileExtraOverlay && mobileExtraOverlay.classList.contains("is-active") && !mobileExtraOverlay.contains(e.target) && !menuToggle.contains(e.target)) {
            mobileExtraOverlay.classList.remove("is-active");
        }
    });
    const dropdownLinks = document.querySelectorAll('.chemistrie-header__dropdown-link:not(.chemistrie-header__dropdown-link--expandable):not([data-action="mobile-clips-menu"]):not([data-action="mobile-extra-menu"])');
    dropdownLinks.forEach(link => {
        link.addEventListener("click", function() {
            if (dropdownMenu) {
                dropdownMenu.classList.remove("is-active");
            }
        });
    });
    const expandableToggles = document.querySelectorAll("[data-mobile-nav-toggle]");
    expandableToggles.forEach(toggle => {
        toggle.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            const navItem = this.closest("[data-mobile-nav-expandable]");
            if (navItem) {
                expandableToggles.forEach(otherToggle => {
                    const otherItem = otherToggle.closest("[data-mobile-nav-expandable]");
                    if (otherItem && otherItem !== navItem) {
                        otherItem.classList.remove("is-expanded");
                    }
                });
                navItem.classList.toggle("is-expanded");
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener("click", function(e) {
        const header = document.querySelector(".chemistrie-header");
        const promotionsDialog = document.querySelector("[data-promotions-dialog]");
        if (header && !header.contains(e.target) && (!promotionsDialog || !promotionsDialog.contains(e.target))) {
            closeAllHeaderElements();
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {
    const megaNavItems = document.querySelectorAll(".chemistrie-header__nav-item--has-mega-menu");
    megaNavItems.forEach(function(navItem) {
        const megaMenuWrapper = navItem.querySelector(".chemistrie-header__mega-menu");
        if (!megaMenuWrapper) return;
        const megaMenu = megaMenuWrapper.querySelector(".clips-mega-menu");
        if (!megaMenu) return;
        const scrollContainer = megaMenu.querySelector(".clips-mega-menu__container");
        const leftArrow = megaMenu.querySelector(".clips-mega-scroll-arrow--left");
        const rightArrow = megaMenu.querySelector(".clips-mega-scroll-arrow--right");
        if (!scrollContainer || !leftArrow || !rightArrow) return;
        let initialStateSet = false;
        function updateScrollState() {
            if (scrollContainer.clientWidth === 0) return;
            const isScrollable = scrollContainer.scrollWidth > scrollContainer.clientWidth;
            const scrollLeft = scrollContainer.scrollLeft;
            const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
            const atStart = scrollLeft <= 10;
            const atEnd = scrollLeft >= maxScroll - 10 || maxScroll <= 0;
            megaMenu.classList.toggle("is-scrollable", isScrollable);
            megaMenu.classList.toggle("at-start", atStart);
            megaMenu.classList.toggle("at-end", atEnd);
        }
        leftArrow.addEventListener("click", function(e) {
            e.stopPropagation();
            scrollContainer.scrollBy({
                left: -800,
                behavior: "smooth"
            });
        });
        rightArrow.addEventListener("click", function(e) {
            e.stopPropagation();
            scrollContainer.scrollBy({
                left: 800,
                behavior: "smooth"
            });
        });
        scrollContainer.addEventListener("scroll", updateScrollState);
        window.addEventListener("resize", updateScrollState);
        navItem.addEventListener("mouseenter", function() {
            requestAnimationFrame(function() {
                setTimeout(function() {
                    if (!initialStateSet) {
                        megaMenu.classList.add("at-start");
                        initialStateSet = true;
                    }
                    updateScrollState();
                }, 50);
            });
        });
        megaMenu.classList.add("at-start");
        updateScrollState();
    });
});

document.addEventListener("DOMContentLoaded", function() {
    function updateHeaderHeight() {
        const header = document.querySelector(".chemistrie-header");
        if (header) {
            const headerHeight = header.offsetHeight;
            const announcementBar = document.querySelector(".announcement-bar");
            const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
            document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
            document.documentElement.style.setProperty("--header-bottom-offset", `${headerHeight + announcementHeight}px`);
        }
    }
    updateHeaderHeight();
    window.addEventListener("resize", updateHeaderHeight);
});

document.addEventListener("DOMContentLoaded", function() {
    const dropdownItems = document.querySelectorAll(".chemistrie-header__nav-item--has-dropdown");
    dropdownItems.forEach(item => {
        const link = item.querySelector(".chemistrie-header__nav-link");
        if (link) {
            link.addEventListener("click", function(e) {
                if (window.innerWidth <= 768) {
                    e.preventDefault();
                    e.stopPropagation();
                    const hamburgerMenu = document.querySelector("[data-dropdown-menu]");
                    if (hamburgerMenu) {
                        hamburgerMenu.classList.remove("is-active");
                    }
                    dropdownItems.forEach(otherItem => {
                        if (otherItem !== item) {
                            otherItem.classList.remove("is-active");
                        }
                    });
                    item.classList.toggle("is-active");
                }
            });
        }
    });
    document.addEventListener("click", function(e) {
        if (window.innerWidth <= 768) {
            const isClickInside = Array.from(dropdownItems).some(item => item.contains(e.target));
            if (!isClickInside) {
                dropdownItems.forEach(item => item.classList.remove("is-active"));
            }
        }
    });
    window.addEventListener("resize", function() {
        if (window.innerWidth > 768) {
            dropdownItems.forEach(item => item.classList.remove("is-active"));
        }
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-color-wheel"] && !Shopify.designMode) return;
  try {
    (function() {
    function init(root) {
        if (!root || root.dataset.cwReady === "1") return;
        root.dataset.cwReady = "1";
        var lens = root.querySelector(".cw__lens");
        var chosen = root.querySelector(".cw__chosen b");
        var pucks = root.querySelectorAll(".cw__puck");
        var tabs = root.querySelectorAll(".cw__tab");
        var fams = root.querySelectorAll(".cw__fam");
        if (!lens) return;
        var warmed = [];
        pucks.forEach(function(p) {
            var src = p.dataset.lens;
            if (!src) return;
            var pre = new Image;
            pre.decoding = "async";
            pre.src = src;
            warmed.push(pre);
        });
        pucks.forEach(function(p) {
            p.addEventListener("click", function() {
                pucks.forEach(function(o) {
                    o.setAttribute("aria-pressed", "false");
                });
                p.setAttribute("aria-pressed", "true");
                if (chosen) chosen.textContent = p.dataset.label;
                var src = p.dataset.lens;
                if (!src || lens.getAttribute("src") === src) return;
                lens.src = src;
            });
        });
        tabs.forEach(function(t) {
            t.addEventListener("click", function() {
                var fam = t.dataset.fam;
                tabs.forEach(function(o) {
                    o.setAttribute("aria-selected", String(o === t));
                });
                fams.forEach(function(f) {
                    if (f.dataset.fam === fam) f.removeAttribute("data-hidden-mobile"); else f.setAttribute("data-hidden-mobile", "true");
                });
            });
        });
    }
    function boot() {
        document.querySelectorAll(".cw").forEach(init);
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", boot);
    } else {
        boot();
    }
    document.addEventListener("shopify:section:load", function(e) {
        var el = e.target.querySelector ? e.target.querySelector(".cw") : null;
        if (el) init(el);
    });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-diagram"] && !Shopify.designMode) return;
  try {
    (function() {
    function wire(root) {
        var specs = root.querySelectorAll("[data-anat-spec]");
        var plate = root.querySelector(".anat__plate");
        if (!specs.length || !plate) return;
        var pins = root.querySelectorAll("[data-anat-pin]");
        var opens = root.querySelectorAll("[data-anat-open]");
        var reset = root.querySelector("[data-anat-reset]");
        function press(list, key, n) {
            for (var i = 0; i < list.length; i++) {
                list[i].setAttribute("aria-pressed", String(list[i].dataset[key] === n));
            }
        }
        function frame(spec) {
            var parts = spec ? (spec.getAttribute("data-anat-zoom") || "").split(" ") : [];
            var on = parts.length === 3;
            plate.style.setProperty("--zs", on ? parts[0] : "1");
            plate.style.setProperty("--zx", on ? parts[1] + "%" : "0%");
            plate.style.setProperty("--zy", on ? parts[2] + "%" : "0%");
            root.classList.toggle("anat--zoomed", on);
        }
        function open(n) {
            var chosen = null;
            for (var i = 0; i < specs.length; i++) {
                var hit = specs[i].dataset.anatSpec === n;
                specs[i].classList.toggle("is-open", hit);
                if (hit) chosen = specs[i];
            }
            press(pins, "anatPin", n);
            press(opens, "anatOpen", n);
            root.classList.toggle("anat--chosen", chosen !== null);
            frame(chosen);
        }
        function clear() {
            open(null);
        }
        for (var a = 0; a < pins.length; a++) {
            pins[a].addEventListener("click", function() {
                open(this.dataset.anatPin);
            });
        }
        for (var b = 0; b < opens.length; b++) {
            opens[b].disabled = false;
            opens[b].addEventListener("click", function() {
                open(this.dataset.anatOpen);
            });
        }
        if (reset) {
            reset.disabled = false;
            reset.addEventListener("click", clear);
        }
        root.addEventListener("keydown", function(e) {
            if (e.key === "Escape") clear();
        });
        root.classList.add("anat--live");
        clear();
    }
    function init() {
        var sections = document.querySelectorAll(".anat");
        for (var i = 0; i < sections.length; i++) wire(sections[i]);
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
    document.addEventListener("shopify:section:load", function(e) {
        var el = e.target.querySelector(".anat");
        if (el) wire(el);
    });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-explore-clips"] && !Shopify.designMode) return;
  try {
    (function() {
    function wire(root) {
        var strips = root.querySelectorAll("[data-xc-strip]");
        var img = root.querySelector(".xc__img");
        if (!strips.length) return;
        var srcs = [];
        for (var i = 0; i < strips.length; i++) srcs.push(strips[i].dataset.xcImg || null);
        var warmed = false;
        function warm() {
            if (warmed) return;
            warmed = true;
            for (var i = 0; i < srcs.length; i++) if (srcs[i]) {
                var pre = new Image;
                pre.src = srcs[i];
            }
        }
        if (window.requestIdleCallback) requestIdleCallback(warm, {
            timeout: 4e3
        }); else setTimeout(warm, 2e3);
        root.addEventListener("pointerenter", warm, {
            once: true,
            capture: true
        });
        function open(n) {
            for (var i = 0; i < strips.length; i++) {
                var on = strips[i].dataset.xcStrip === n;
                strips[i].classList.toggle("is-open", on);
                var btn = strips[i].querySelector(".xc__rail");
                if (btn) btn.setAttribute("aria-expanded", String(on));
                if (on && img && srcs[i]) {
                    img.removeAttribute("srcset");
                    img.removeAttribute("sizes");
                    img.src = srcs[i];
                }
            }
        }
        root.addEventListener("click", function(e) {
            var b = e.target.closest("[data-xc-open]");
            if (b && root.contains(b)) open(b.dataset.xcOpen);
        });
        root.classList.add("xc--live");
        open(strips[0].dataset.xcStrip);
    }
    function init() {
        var all = document.querySelectorAll(".xc");
        for (var i = 0; i < all.length; i++) wire(all[i]);
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
    document.addEventListener("shopify:section:load", function(e) {
        var el = e.target.querySelector(".xc");
        if (el) wire(el);
    });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-gallery"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll(".hg").forEach(function(section) {
        var dlg = section.parentNode.querySelector(".hg__lb");
        if (!dlg) return;
        var stage = dlg.querySelector(".hg__lbstage");
        section.querySelectorAll("[data-hg-open]").forEach(function(tile) {
            tile.addEventListener("click", function() {
                var vid = tile.querySelector("video");
                var node;
                if (vid) {
                    node = document.createElement("video");
                    node.src = vid.currentSrc || vid.src;
                    node.autoplay = true;
                    node.loop = true;
                    node.muted = true;
                    node.playsInline = true;
                } else {
                    var img = tile.querySelector("img");
                    if (!img) return;
                    node = document.createElement("img");
                    node.src = img.getAttribute("data-hg-full") || img.currentSrc || img.src;
                    node.alt = img.alt || "";
                }
                stage.replaceChildren(node);
                if (typeof dlg.showModal === "function") dlg.showModal();
            });
        });
        dlg.querySelector(".hg__lbclose").addEventListener("click", function() {
            dlg.close();
        });
        dlg.addEventListener("click", function(e) {
            if (e.target === dlg) dlg.close();
        });
        dlg.addEventListener("close", function() {
            stage.replaceChildren();
        });
        var vids = section.querySelectorAll("[data-hg-video]");
        if (vids.length && "IntersectionObserver" in window) {
            var io = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    var v = entry.target;
                    if (entry.isIntersecting) {
                        if (!v.dataset.hgLoaded) {
                            v.preload = "auto";
                            v.load();
                            v.dataset.hgLoaded = "1";
                        }
                        var p = v.play();
                        if (p && p.catch) p.catch(function() {});
                    } else {
                        v.pause();
                    }
                });
            }, {
                rootMargin: "200px"
            });
            vids.forEach(function(v) {
                io.observe(v);
            });
        }
    });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    (function() {
    var LIFT = 380, TRAVEL = 760, CLICK = 340, HOLD = 1700;
    var SHADOW = 300;
    var RESUME = 600;
    function wire(rig) {
        var clips = rig.querySelectorAll("[data-hero-clip]");
        var n = clips.length;
        if (n < 2) {
            return;
        }
        if (rig.dataset.heroWired === "1" && rig.heroStop) {
            rig.heroStop();
        }
        rig.dataset.heroWired = "1";
        var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        var active = 0;
        var timer = null;
        var paused = false;
        var pending = false;
        function paint(dur) {
            rig.style.setProperty("--hero-dur", dur + "ms");
            rig.style.setProperty("--hero-sh-dur", (reduced ? 0 : SHADOW) + "ms");
            for (var i = 0; i < n; i++) {
                var rel = active - i;
                if (rel > n / 2) {
                    rel -= n;
                }
                if (rel < -n / 2) {
                    rel += n;
                }
                clips[i].style.setProperty("--rel", rel);
                clips[i].classList.toggle("is-near", reduced ? rel === 0 : rel >= -1 && rel <= 2);
            }
        }
        function air(list) {
            for (var i = 0; i < n; i++) {
                clips[i].classList.toggle("is-air", list.indexOf(i) !== -1);
            }
        }
        function queue(delay) {
            timer = setTimeout(function() {
                if (paused) {
                    pending = true;
                    return;
                }
                cycle();
            }, delay);
        }
        function cycle() {
            air([ active ]);
            paint(LIFT);
            timer = setTimeout(function() {
                active = (active + 1) % n;
                air([ active ]);
                paint(TRAVEL);
                timer = setTimeout(function() {
                    air([]);
                    paint(CLICK);
                    queue(HOLD);
                }, TRAVEL);
            }, LIFT);
        }
        function hold(on) {
            if (reduced) {
                return;
            }
            paused = on;
            if (!on && pending) {
                pending = false;
                queue(RESUME);
            }
        }
        rig.heroStop = function() {
            clearTimeout(timer);
            timer = null;
            pending = false;
            paused = false;
        };
        rig.addEventListener("pointerenter", function(e) {
            if (e.pointerType !== "touch") {
                hold(true);
            }
        });
        rig.addEventListener("pointerleave", function(e) {
            if (e.pointerType !== "touch") {
                hold(false);
            }
        });
        air([]);
        paint(0);
        rig.classList.add("is-live");
        if (!reduced) {
            queue(HOLD);
        }
    }
    function init(scope) {
        var rigs = (scope || document).querySelectorAll("[data-hero-rig]");
        for (var i = 0; i < rigs.length; i++) {
            wire(rigs[i]);
        }
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function() {
            init();
        });
    } else {
        init();
    }
    document.addEventListener("shopify:section:load", function(e) {
        init(e.target);
    });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-rail"] && !Shopify.designMode) return;
  try {
    (function() {
    function init(root) {
        if (!root || root.dataset.phReady === "1") return;
        root.dataset.phReady = "1";
        var track = root.querySelector(".ph-rail__track");
        var prev = root.querySelector(".ph-rail__arrow--prev");
        var next = root.querySelector(".ph-rail__arrow--next");
        if (!track || !prev || !next) return;
        function step() {
            var card = track.querySelector(".ph-card");
            if (!card) return track.clientWidth;
            var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
            return card.getBoundingClientRect().width + gap;
        }
        function sync() {
            var max = track.scrollWidth - track.clientWidth;
            prev.disabled = track.scrollLeft <= 1;
            next.disabled = track.scrollLeft >= max - 1;
            var idle = max <= 1;
            root.querySelector(".ph-rail__nav").hidden = idle;
        }
        prev.addEventListener("click", function() {
            track.scrollBy({
                left: -step(),
                behavior: "smooth"
            });
        });
        next.addEventListener("click", function() {
            track.scrollBy({
                left: step(),
                behavior: "smooth"
            });
        });
        track.addEventListener("scroll", sync, {
            passive: true
        });
        var t = null;
        window.addEventListener("resize", function() {
            clearTimeout(t);
            t = setTimeout(sync, 150);
        });
        sync();
    }
    function boot() {
        document.querySelectorAll(".ph-rail").forEach(init);
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", boot);
    } else {
        boot();
    }
    document.addEventListener("shopify:section:load", function(e) {
        var el = e.target.querySelector ? e.target.querySelector(".ph-rail") : null;
        if (el) init(el);
    });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-reviews"] && !Shopify.designMode) return;
  try {
    (function() {
    var STARS_FULL = "★", STARS_EMPTY = "☆";
    function stars(n) {
        var s = document.createElement("span");
        s.className = "rvs__stars";
        var r = Math.max(0, Math.min(5, Math.round(n || 0)));
        s.textContent = STARS_FULL.repeat(r) + STARS_EMPTY.repeat(5 - r);
        s.setAttribute("aria-label", r + " out of 5");
        return s;
    }
    function card(rev) {
        var a = document.createElement("article");
        a.className = "rvs__card";
        var top = document.createElement("span");
        top.className = "rvs__top";
        top.appendChild(stars(rev.rating));
        var t = document.createElement("h3");
        t.className = "rvs__t";
        t.textContent = rev.title || "";
        top.appendChild(t);
        a.appendChild(top);
        var b = document.createElement("p");
        b.className = "rvs__body";
        b.textContent = rev.body || "";
        a.appendChild(b);
        var n = document.createElement("span");
        n.className = "rvs__name";
        n.textContent = rev.reviewer && rev.reviewer.displayName || "";
        a.appendChild(n);
        return a;
    }
    document.querySelectorAll("[data-rvs]").forEach(function(sec) {
        var out = sec.querySelector("[data-rvs-out]");
        var sub = sec.dataset.subscriber;
        if (!out || !sub) return;
        var want = parseInt(sec.dataset.count, 10) || 12;
        var allow = (sec.dataset.filter || "").split(",").map(function(x) {
            return x.trim().toLowerCase();
        }).filter(Boolean);
        fetch("https://api.okendo.io/v1/stores/" + encodeURIComponent(sub) + "/reviews?limit=" + encodeURIComponent(sec.dataset.limit)).then(function(r) {
            return r.ok ? r.json() : Promise.reject(r.status);
        }).then(function(d) {
            var rs = d && d.reviews || [];
            rs = rs.filter(function(r) {
                return r.title || r.body;
            });
            if (allow.length) {
                rs = rs.filter(function(r) {
                    return allow.indexOf(String(r.productName || "").toLowerCase()) !== -1;
                });
            }
            rs = rs.slice(0, want);
            if (!rs.length) return;
            var frag = document.createDocumentFragment();
            rs.forEach(function(r) {
                frag.appendChild(card(r));
            });
            if (sec.dataset.layout === "ticker") {
                var dup = frag.cloneNode(true);
                [].forEach.call(dup.children, function(el) {
                    el.setAttribute("aria-hidden", "true");
                });
                out.appendChild(frag);
                out.appendChild(dup);
            } else {
                out.appendChild(frag);
            }
            sec.hidden = false;
        }).catch(function() {});
    });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-video"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    var q = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!q) return;
    function apply() {
        var players = document.querySelectorAll(".home-video__media");
        for (var i = 0; i < players.length; i++) {
            var v = players[i];
            if (q.matches) {
                v.autoplay = false;
                v.removeAttribute("autoplay");
                v.pause();
                try {
                    v.currentTime = 0;
                } catch (e) {}
                v.setAttribute("controls", "");
            } else {
                v.removeAttribute("controls");
            }
        }
    }
    apply();
    if (q.addEventListener) q.addEventListener("change", apply); else if (q.addListener) q.addListener(apply);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-pain-accordion"] && !Shopify.designMode) return;
  try {
    (function() {
    var REDUCE = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function panelOf(item) {
        return item.querySelector(".lp-accordion__panel");
    }
    function openItem(item) {
        item.setAttribute("open", "");
        var panel = panelOf(item);
        if (REDUCE || !panel || !panel.animate) {
            return;
        }
        var end = panel.scrollHeight;
        panel.animate([ {
            height: "0px"
        }, {
            height: end + "px"
        } ], {
            duration: 300,
            easing: "ease"
        });
    }
    function closeItem(item) {
        if (!item.hasAttribute("open")) {
            return;
        }
        var panel = panelOf(item);
        if (REDUCE || !panel || !panel.animate) {
            item.removeAttribute("open");
            return;
        }
        var start = panel.scrollHeight;
        var anim = panel.animate([ {
            height: start + "px"
        }, {
            height: "0px"
        } ], {
            duration: 300,
            easing: "ease"
        });
        anim.onfinish = function() {
            item.removeAttribute("open");
        };
    }
    function initAccordion(root) {
        if (root.dataset.lpAccordionReady) {
            return;
        }
        root.dataset.lpAccordionReady = "true";
        var items = Array.prototype.slice.call(root.querySelectorAll(".lp-accordion__item"));
        items.forEach(function(item) {
            var summary = item.querySelector(".lp-accordion__summary");
            if (!summary) {
                return;
            }
            summary.addEventListener("click", function(event) {
                event.preventDefault();
                var isOpen = item.hasAttribute("open");
                items.forEach(function(other) {
                    if (other !== item) {
                        closeItem(other);
                    }
                });
                if (isOpen) {
                    closeItem(item);
                } else {
                    openItem(item);
                }
            });
        });
    }
    function initAll(scope) {
        (scope || document).querySelectorAll(".lp-accordion").forEach(initAccordion);
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function() {
            initAll();
        });
    } else {
        initAll();
    }
    document.addEventListener("shopify:section:load", function(event) {
        initAll(event.target);
    });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp2-before-after"] && !Shopify.designMode) return;
  try {
    (function() {
    function clamp(v) {
        return Math.min(96, Math.max(4, v));
    }
    function setPos(frame, handle, pos) {
        var p = clamp(pos);
        frame.style.setProperty("--lp2-pos", p + "%");
        handle.setAttribute("aria-valuenow", Math.round(p));
    }
    function currentPos(frame) {
        return parseFloat(frame.style.getPropertyValue("--lp2-pos")) || 50;
    }
    function init(frame) {
        if (frame.dataset.lp2BaReady) {
            return;
        }
        frame.dataset.lp2BaReady = "true";
        var handle = frame.querySelector(".lp2-ba__handle");
        if (!handle) {
            return;
        }
        var dragging = false;
        function posFromEvent(event) {
            var rect = frame.getBoundingClientRect();
            return (event.clientX - rect.left) / rect.width * 100;
        }
        handle.addEventListener("pointerdown", function(event) {
            event.preventDefault();
            dragging = true;
            try {
                handle.setPointerCapture(event.pointerId);
            } catch (err) {}
        });
        handle.addEventListener("pointermove", function(event) {
            if (!dragging) {
                return;
            }
            setPos(frame, handle, posFromEvent(event));
        });
        function endDrag(event) {
            dragging = false;
            try {
                handle.releasePointerCapture(event.pointerId);
            } catch (err) {}
        }
        handle.addEventListener("pointerup", endDrag);
        handle.addEventListener("pointercancel", endDrag);
        frame.addEventListener("pointerdown", function(event) {
            if (event.target === handle || handle.contains(event.target)) {
                return;
            }
            setPos(frame, handle, posFromEvent(event));
        });
        handle.addEventListener("keydown", function(event) {
            var step = event.shiftKey ? 10 : 2;
            var pos = currentPos(frame);
            if (event.key === "ArrowLeft" || event.key === "ArrowDown") {
                setPos(frame, handle, pos - step);
                event.preventDefault();
            } else if (event.key === "ArrowRight" || event.key === "ArrowUp") {
                setPos(frame, handle, pos + step);
                event.preventDefault();
            } else if (event.key === "Home") {
                setPos(frame, handle, 4);
                event.preventDefault();
            } else if (event.key === "End") {
                setPos(frame, handle, 96);
                event.preventDefault();
            }
        });
    }
    function initAll(scope) {
        (scope || document).querySelectorAll(".lp2-ba__frame").forEach(init);
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function() {
            initAll();
        });
    } else {
        initAll();
    }
    document.addEventListener("shopify:section:load", function(event) {
        initAll(event.target);
    });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["post-order-page"]) return;
  try {
    (function() {
    var root = document.querySelector(".post-order");
    if (!root) return;
    window.addEventListener("pageshow", function(e) {
        if (e.persisted && window.cartDrawer && window.cartDrawer.isOpen) {
            window.cartDrawer.closeDrawer();
        }
    });
    var tabs = Array.prototype.slice.call(root.querySelectorAll(".post-order__tab"));
    var panels = Array.prototype.slice.call(root.querySelectorAll(".post-order__panel"));
    var prompt = root.querySelector("[data-post-order-prompt]");
    if (!tabs.length || tabs.length !== panels.length) return;
    var FROM_ORDER = {
        "own-frame-own-lenses": "own_frames_own_lenses",
        "own-frame-new-lenses": "own_frames_new_lenses",
        "new-frame-lenses": "new_frames_lenses"
    };
    function select(index, focus) {
        tabs.forEach(function(tab, i) {
            var on = i === index;
            tab.setAttribute("aria-selected", on ? "true" : "false");
            tab.tabIndex = on ? 0 : -1;
            panels[i].hidden = !on;
        });
        if (prompt) prompt.hidden = index !== -1;
        if (focus && index > -1) tabs[index].focus();
    }
    panels.forEach(function(p) {
        p.hidden = true;
    });
    tabs.forEach(function(t) {
        t.tabIndex = -1;
    });
    var preselect = -1;
    try {
        var raw = window.localStorage.getItem("chemistrie_last_order");
        if (raw) {
            var choice = (JSON.parse(raw) || {}).frameChoice;
            var wanted = FROM_ORDER[choice];
            if (wanted) {
                tabs.forEach(function(t, i) {
                    if (t.getAttribute("data-variant") === wanted) preselect = i;
                });
            }
        }
    } catch (e) {}
    select(preselect, false);
    tabs.forEach(function(tab, i) {
        tab.addEventListener("click", function() {
            select(i, false);
        });
        tab.addEventListener("keydown", function(e) {
            var next = null;
            if (e.key === "ArrowRight" || e.key === "ArrowDown") next = (i + 1) % tabs.length;
            if (e.key === "ArrowLeft" || e.key === "ArrowUp") next = (i - 1 + tabs.length) % tabs.length;
            if (e.key === "Home") next = 0;
            if (e.key === "End") next = tabs.length - 1;
            if (next === null) return;
            e.preventDefault();
            select(next, true);
        });
    });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-feature"] && !Shopify.designMode) return;
  try {
    (function() {
    var BP = 1070;
    var RATE = .42;
    function normalize(img) {
        if (!img.naturalWidth || !img.naturalHeight) return;
        var ar = img.naturalWidth / img.naturalHeight;
        img.style.setProperty("--hu", (1 / Math.sqrt(ar)).toFixed(4));
    }
    function init(root) {
        if (!root || root.dataset.pfReady === "1") return;
        root.dataset.pfReady = "1";
        var strip = root.querySelector(".press-feature__strip");
        var track = root.querySelector(".press-feature__track");
        var prev = root.querySelector(".press-feature__nav--prev");
        var next = root.querySelector(".press-feature__nav--next");
        if (!strip || !track) return;
        root.querySelectorAll(".press-feature__logo").forEach(function(img) {
            if (img.complete) normalize(img); else img.addEventListener("load", function() {
                normalize(img);
            }, {
                once: true
            });
        });
        var reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
        var originals = Array.prototype.slice.call(track.children);
        var cloned = false;
        var raf = null;
        var pos = 0;
        var wrapAt = 0;
        var stopped = false;
        function addClones() {
            if (cloned) return;
            originals.forEach(function(li) {
                var c = li.cloneNode(true);
                c.setAttribute("aria-hidden", "true");
                c.querySelectorAll("a").forEach(function(a) {
                    a.setAttribute("tabindex", "-1");
                });
                track.appendChild(c);
            });
            cloned = true;
        }
        function measure() {
            var first = originals[0];
            var firstClone = track.children[originals.length];
            wrapAt = first && firstClone ? firstClone.offsetLeft - first.offsetLeft : 0;
        }
        function stopDrift() {
            if (raf) cancelAnimationFrame(raf);
            raf = null;
        }
        function surrender() {
            if (stopped) return;
            stopped = true;
            stopDrift();
            strip.classList.add("is-manual");
        }
        function tick() {
            if (wrapAt <= 0) measure();
            pos += RATE;
            if (wrapAt > 0 && pos >= wrapAt) pos -= wrapAt;
            track.scrollLeft = pos;
            raf = requestAnimationFrame(tick);
        }
        function startDrift() {
            stopDrift();
            if (stopped || reduce.matches) return;
            if (window.innerWidth >= BP) return;
            addClones();
            measure();
            pos = track.scrollLeft;
            raf = requestAnimationFrame(tick);
        }
        [ "pointerdown", "touchstart", "wheel" ].forEach(function(e) {
            track.addEventListener(e, surrender, {
                passive: true
            });
        });
        function nudge(dir) {
            surrender();
            addClones();
            track.scrollBy({
                left: dir * track.clientWidth * .62,
                behavior: "smooth"
            });
        }
        if (prev) prev.addEventListener("click", function() {
            nudge(-1);
        });
        if (next) next.addEventListener("click", function() {
            nudge(1);
        });
        var t = null;
        window.addEventListener("resize", function() {
            clearTimeout(t);
            t = setTimeout(function() {
                wrapAt = 0;
                if (window.innerWidth >= BP) stopDrift(); else startDrift();
            }, 180);
        });
        reduce.addEventListener("change", function() {
            if (reduce.matches) stopDrift(); else startDrift();
        });
        window.addEventListener("load", startDrift);
        startDrift();
    }
    function boot() {
        document.querySelectorAll(".press-feature").forEach(init);
    }
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", boot);
    } else {
        boot();
    }
    document.addEventListener("shopify:section:load", function(e) {
        var el = e.target.querySelector ? e.target.querySelector(".press-feature") : null;
        if (el) init(el);
    });
})();
  } catch(e) { console.error(e); }
})();
})();
